var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurcustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1117,
    height: 697,
    viewBox: "0 0 1117 697",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4965)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4965",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 555,
    width: 1117,
    height: 143
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1117 555.816H0V697.137L1117 697V555.816Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1055.29 555.816C1063.61 585.872 1114.65 762.843 1037.4 883.864C960.157 1004.89 843.63 1068.1 683.732 1064.81C567.786 1062.42 455.325 1028.76 377.847 926.819C300.369 824.874 219.712 873.791 103.962 806.295C25.0268 760.267 14.9411 640.1 58.3745 555.816H1055.29Z",
    fill: "url(#paint0_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.017 555.816C109.447 585.451 113.565 653.683 73.7698 667.415C33.9748 681.149 16.1356 643.901 32.6017 618.212C49.0692 592.524 85.0202 586.548 87.6281 555.816H106.017Z",
    fill: "url(#paint1_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7569 568.816C97.3265 572.308 96.7441 575.788 96.0665 579.245C94.6993 586.22 92.8853 593.119 90.6275 599.888C86.091 613.49 79.797 626.731 71.707 638.817C67.0841 645.723 61.9861 652.371 56.2626 658.519C55.9692 658.834 55.8173 658.322 56.0049 658.095C65.413 646.751 73.6133 634.489 80.0398 621.434C86.3054 608.707 91.0355 595.297 93.9293 581.542C94.738 577.697 95.4067 573.828 95.934 569.941C96.1946 568.012 96.4478 566.083 96.6563 564.148C96.8782 562.08 97.0792 560.023 97.6229 558.006C97.6973 557.73 98.1992 557.497 98.2633 557.901C98.8277 561.463 98.1963 565.261 97.7569 568.816Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1092 587.555C28.7442 586.531 30.7518 571.071 45.7077 567.575C59.353 564.384 68.712 565.796 78.2824 555.817H82.8353C78.6324 568.547 66.8875 588.658 47.1092 587.555Z",
    fill: "url(#paint2_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9481 559.644C77.9235 562.381 76.038 564.885 74.0512 567.089C72.0734 569.282 69.8349 571.274 67.4028 573.02C62.5833 576.483 56.9998 579.001 51.0812 580.3C47.7957 581.021 44.4522 581.324 41.0982 580.973C40.9865 580.962 40.9776 580.735 41.0923 580.728C47.2402 580.328 53.2408 579.253 58.8555 576.809C64.1769 574.494 68.989 571.147 72.8344 566.991C75.0163 564.634 76.729 562.026 78.5654 559.437C78.762 559.161 79.0598 559.344 78.9481 559.644Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.54 555.816C1010.11 585.451 1005.99 653.683 1045.79 667.415C1085.58 681.149 1103.42 643.901 1086.96 618.212C1070.49 592.524 1034.54 586.548 1031.93 555.816H1013.54Z",
    fill: "url(#paint3_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.32 567.545C1021.75 571.037 1022.33 574.516 1023.01 577.973C1024.38 584.949 1026.19 591.848 1028.45 598.617C1032.98 612.218 1039.28 625.46 1047.37 637.546C1051.99 644.452 1057.09 651.1 1062.81 657.247C1063.11 657.562 1063.26 657.051 1063.07 656.824C1053.66 645.478 1045.46 633.216 1039.04 620.163C1032.77 607.436 1028.04 594.025 1025.15 580.271C1024.34 576.426 1023.67 572.556 1023.14 568.67C1022.88 566.741 1022.63 564.811 1022.42 562.876C1022.2 560.809 1022 558.75 1021.45 556.734C1021.38 556.458 1020.87 556.226 1020.81 556.63C1020.25 560.19 1020.88 563.989 1021.32 567.545Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.45 587.555C1090.81 586.531 1088.81 571.071 1073.85 567.575C1060.21 564.384 1050.85 565.796 1041.28 555.817H1036.72C1040.93 568.547 1052.67 588.658 1072.45 587.555Z",
    fill: "url(#paint4_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.61 559.644C1041.64 562.381 1043.52 564.885 1045.51 567.089C1047.49 569.282 1049.72 571.274 1052.16 573.02C1056.98 576.483 1062.56 579.001 1068.48 580.3C1071.76 581.021 1075.11 581.324 1078.46 580.973C1078.57 580.962 1078.58 580.735 1078.47 580.728C1072.32 580.328 1066.32 579.253 1060.7 576.809C1055.38 574.494 1050.57 571.147 1046.72 566.991C1044.54 564.634 1042.83 562.026 1040.99 559.437C1040.8 559.161 1040.5 559.344 1040.61 559.644Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.301 555.816H632.447V581.458H773.301V555.816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.438 661.665C496.495 659.315 494.994 655.133 494.666 650.555C494.201 644.07 495.336 639.288 497.54 633.126C497.54 633.126 499.798 633.061 502.859 633.061C505.919 633.061 507.617 632.473 509.036 632.054C512.815 630.937 513.887 629.861 517.153 627.745C520.093 625.838 543.546 614.979 547.951 614.248C551.929 613.589 553.971 613.049 556.141 613.274C559.371 613.608 564.122 615.093 561.278 619.51C566.623 616.522 572.649 618.286 572.226 623.068C575.09 620.81 580.023 620.525 582.554 623.142C583.646 624.278 583.053 626.504 582.484 627.879C574.108 648.082 569.258 647.906 546.081 657.774C538.436 661.029 532.934 662.761 524.992 662.892C518.355 663.003 502.119 662.409 498.438 661.665Z",
    fill: "#D18080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.797 613.643C544.821 614.106 545.862 614.588 546.653 615.351C547.443 616.115 547.945 617.226 547.649 618.253C546.734 621.419 541.739 620.963 539.166 620.649C539.647 621.101 540.129 621.553 540.61 622.004C541.486 622.825 542.42 623.772 542.429 624.932C542.436 625.818 541.866 626.648 541.102 627.172C540.338 627.696 539.401 627.954 538.469 628.106C537.483 628.267 536.476 628.322 535.475 628.267C535.289 628.258 533.645 628.235 533.613 628.203C534.398 628.997 535.136 629.868 535.5 630.894C536.477 633.644 533.761 635.744 530.959 635.587C529.489 635.505 528.104 634.936 526.783 634.327C522.591 632.394 517.675 630.032 515.193 626.183C514.507 625.118 513.984 623.692 514.817 622.612C515.74 621.413 517.356 620.719 518.879 620.497C520.854 620.21 522.862 620.575 524.822 620.938C523.916 620.004 523.778 618.547 524.31 617.387C525.66 614.442 529.641 614.725 532.501 615.094C532.227 614.283 532.788 613.391 533.563 612.946C536.859 611.054 540.592 612.195 543.797 613.643Z",
    fill: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.133 663.346C565.201 665.005 559.349 667.09 553.201 667.778C551.375 667.981 549.49 668.057 547.729 667.56C545.812 667.019 544.183 665.843 542.642 664.648C537.493 660.656 532.781 656.17 528.603 651.284C528.357 650.997 528.11 650.703 527.978 650.358C527.677 649.576 528.043 648.666 528.697 648.103C529.349 647.538 530.235 647.269 531.113 647.137C534.82 646.575 538.527 648.189 541.562 650.261C543.321 651.461 545.016 652.858 547.111 653.407C549.588 654.055 552.228 653.411 554.662 652.632C560.785 650.669 566.234 648.34 569.809 645.828C571.515 644.629 574.232 640.773 577.018 636.542C578.807 633.828 582.484 627.883 582.484 627.883L597.348 633.094C596.45 639.761 595.55 646.443 593.971 653.004C593.409 655.347 591.851 661.903 591.851 661.903C591.851 661.903 587.238 661.403 584.507 661.584C580.621 661.838 574.853 662.306 571.133 663.346Z",
    fill: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.939 667.725L588.6 663.43L596.861 627.991L610.125 631.962L599.939 667.725Z",
    fill: "url(#paint5_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.861 687.758L596.359 667.778L607.177 627.559L636.854 637.107L638.861 687.758Z",
    fill: "#223F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.183 777.764L660.503 766.735C660.503 766.735 646.273 718.119 643.963 667.515C641.653 616.912 643.038 581.46 643.038 581.46C667.4 572.668 715.966 577.053 764.57 581.46V763.102L738.053 781.334C738.053 781.334 699.101 766.042 692.557 766.735C686.013 767.428 687.183 777.764 687.183 777.764Z",
    fill: "url(#paint6_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.569 716.764L702.873 703.896C694.952 657.575 693.127 607.969 687.463 599.872C678.24 586.684 664.154 584.218 642.748 593.475C642.87 585.756 643.036 581.46 643.036 581.46C667.399 572.668 715.965 577.053 764.569 581.46V716.764Z",
    fill: "#B2D4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.183 777.764C678.542 767.485 669.667 755.442 662.548 728.019C655.429 700.597 651.435 657.026 651.435 634.472C651.435 611.919 650.644 574.221 650.644 574.221L632.449 581.46C633.637 627.039 636.483 696.856 648.59 745.409C653.284 764.234 657.674 769.535 669.889 775.174C682.105 780.813 690.79 783.632 690.79 783.632L687.183 777.764Z",
    fill: "url(#paint7_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.343 750.927C676.08 731.935 657.925 665.338 658.582 654.904C659.237 644.47 663.437 609.483 668.715 608.562C673.993 607.642 685.701 642.935 686.896 650.606C688.091 658.279 690.699 749.721 690.699 749.721L683.343 750.927Z",
    fill: "url(#paint8_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.701 787.013C738.69 778.825 723.043 764.157 712.408 735.002C701.773 705.846 698.755 689.988 697.157 650.686C695.666 613.999 697.883 572.583 697.883 572.583L773.299 581.46C773.299 581.46 764.839 639.389 766.761 664.654C768.684 689.919 772.727 772.436 772.727 772.436C772.727 772.436 753.165 776.768 740.701 787.013Z",
    fill: "url(#paint9_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.317 776.768C742.187 771.576 742.003 761.209 741.921 756.023C736.004 751.19 728.112 743.798 721.602 738.028C721.176 724.806 720.485 698.453 720.227 685.229C713.842 674.999 705.63 661.708 700.812 649.534C706.409 662.009 714.386 673.485 721.46 685.2C721.898 698.299 722.605 724.653 722.876 737.752L722.683 737.337C729.337 743.54 736.339 749.681 742.713 756.022C742.628 761.173 742.443 771.615 742.317 776.768Z",
    fill: "#223F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.729 772.436C783.103 767.97 790.519 758.829 795.045 746.345C799.571 733.86 822.803 660.999 825.518 651.68C828.233 642.361 830.647 634.453 818.579 617.791C806.511 601.13 780.633 555.816 780.633 555.816H732.987C732.987 555.816 756.969 611.164 762.098 621.332C767.227 631.499 768.332 643.279 760.34 665.837C753.196 686.005 749.371 698.528 747.821 708.413C746.271 718.296 751.491 757.868 772.729 772.436Z",
    fill: "#223F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.186 581.459C342.599 570.374 341.114 555.817 341.114 555.817H497.442V581.459H347.186Z",
    fill: "#223F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.497 770.058L453.548 724.972L438.61 764.042L454.464 760.07C454.464 760.07 478.853 719.549 484.342 698.147C489.83 676.745 493.488 581.46 493.488 581.46C478.116 568.806 412.39 576.137 351.722 581.46C351.722 581.46 367.925 618.277 369.754 631.973C371.583 645.669 354.51 708.449 351.767 721.005C349.024 733.56 348.109 741.265 351.767 746.116C355.423 750.967 388.497 770.058 388.497 770.058Z",
    fill: "url(#paint10_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.175 588.948C478.049 583.774 457.775 584.193 455.059 588.646C451.588 594.33 455.059 608.544 455.059 608.544L491.41 624.286C491.084 630.018 490.724 635.98 490.329 641.944L412.809 634.531L369.742 637.691C369.919 635.343 369.94 633.385 369.753 631.973C367.924 618.275 351.721 581.46 351.721 581.46C412.389 576.137 478.115 568.806 493.486 581.46C493.486 581.46 493.379 584.238 493.175 588.948Z",
    fill: "#B2D4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.497 770.058C388.497 770.058 413.579 744.506 427.856 717.326C440.178 693.866 442.68 688.067 445.888 646.044C449.095 604.02 447.448 568.639 447.448 568.639C409.336 566.041 375.248 569.336 347.186 581.461C347.186 581.461 357.631 615.392 361.55 629.401C365.47 643.409 360.837 661.134 354.068 685.79C347.298 710.445 343.735 735.625 344.447 741.629C345.159 747.63 361.75 753.327 388.497 770.058Z",
    fill: "url(#paint11_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.609 764.04C454.662 746.9 471.703 717.928 475.529 696.769C479.356 675.609 482.485 571.78 482.485 571.78C490.314 573.956 496.222 576.841 497.441 581.46C497.441 581.46 492.989 665.192 490.205 689.932C487.423 714.673 459.035 758.945 459.035 758.945L438.609 764.04Z",
    fill: "url(#paint12_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.853 660.548L498.967 661.705C498.967 661.705 495.853 654.893 496.283 646.014C496.714 637.136 498.967 631.688 498.967 631.688L484.318 629.029C484.318 629.029 482.054 633.807 481.515 643.795C480.976 653.783 483.853 660.548 483.853 660.548Z",
    fill: "url(#paint13_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.022 745.303C340.807 739.379 340.212 730.325 347.016 698.434C353.821 666.544 375.923 625.383 379.816 617.184C383.71 608.983 389.55 604.123 407.723 607.769C425.894 611.414 486.576 626.645 486.576 626.645C482.897 636.893 481.791 649.968 483.98 661.224L419.73 653.327C419.73 653.327 409.159 692.92 405.371 704.919C397.981 728.336 374.556 760.183 347.022 745.303Z",
    fill: "url(#paint14_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.452 653.995C416.626 667.751 412.992 681.577 408.789 695.237C405.014 707.505 400.235 719.929 391.521 729.953C386.907 735.26 381.383 739.953 374.928 743.226C374.855 743.264 374.839 743.097 374.898 743.062C385.819 736.796 393.47 726.899 398.952 716.234C405.386 703.718 408.745 690.044 412.502 676.678C414.607 669.195 416.731 661.718 418.851 654.239C418.877 654.151 418.816 654.062 418.72 654.045C411.814 652.837 404.929 651.529 398.208 649.608C398.068 649.568 398.109 649.271 398.26 649.293C403.763 650.116 409.229 651.143 414.696 652.148C416.598 652.498 418.668 652.841 420.634 653.203C420.634 653.203 420.515 653.772 420.452 653.995Z",
    fill: "#5586FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.041 656.437C443.96 656.425 422.494 654.493 418.722 654.044C418.385 654.003 420.038 653.095 420.308 653.136C421.756 653.359 445.067 656.437 445.041 656.437Z",
    fill: "#5586FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.794 631.987C469.344 634.03 469.005 636.091 468.747 638.162C468.498 640.172 468.339 642.191 468.281 644.213C468.218 646.357 468.474 648.552 468.214 650.683C468.187 650.902 467.824 651.142 467.733 650.831C467.153 648.875 467.289 646.678 467.319 644.661C467.35 642.57 467.481 640.482 467.716 638.403C467.958 636.28 468.328 634.168 468.793 632.079C469.27 629.94 469.804 627.874 470.816 625.898C470.932 625.672 471.13 625.79 471.103 626.008C470.857 628.039 470.233 629.989 469.794 631.987Z",
    fill: "#5586FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.769 581.549L137.862 555.816H284.537V581.549H140.769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.183 706.888C310.183 706.888 325.776 716.459 333.372 720.255C345.483 726.309 348.983 729.009 355.024 727.712C364.097 725.766 371.609 724.626 371.435 721.416C371.261 718.205 363.634 717.447 357.959 718.412C365.007 714.824 371.922 713.53 380.568 713.968C389.213 714.407 390.851 713.328 392.362 711.031C393.87 708.733 391.493 706.61 391.493 706.61C394.126 706.814 397.585 706.407 398.837 703.043C399.866 700.283 396.964 697.629 395.211 697.346C397.896 695.179 395.914 689.945 391.341 689.357C392.54 687.031 390.346 683.5 383.327 682.904C374.574 682.158 364.219 683.106 356.47 684.393C342.622 686.69 342.107 684.687 337.532 681.8C331.644 678.085 328.706 676.305 328.706 676.305C328.706 676.305 321.76 676.146 315.131 687.459C308.502 698.774 310.183 706.888 310.183 706.888Z",
    fill: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.46 705.544L321.015 713.978C321.015 713.978 321.015 704.465 326.88 694.559C332.745 684.653 340.598 682.473 340.598 682.473L327.404 673.964C327.404 673.964 309.601 683.184 306.46 705.544Z",
    fill: "url(#paint15_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.34 689.358C389.049 693.031 383.396 692.387 379.512 692.343C375.292 692.219 371.052 692.532 366.863 693.066C368.909 692.507 371.024 692.201 373.139 691.964C377.343 691.352 381.655 692.053 385.85 691.722C387.868 691.505 390.169 691.085 391.34 689.358Z",
    fill: "#FB929C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.831 709.468C311.229 702.363 318.634 680.913 332.736 675.776C332.736 675.776 289.692 641.817 284.099 636.857C278.508 631.897 273.308 629.397 270.616 629.692C267.925 629.988 274.836 690.54 274.836 690.54L312.831 709.468Z",
    fill: "#223F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.59 697.099C303.918 694.51 304.311 692 304.999 689.47C305.61 687.225 306.45 685.028 307.505 682.933C308.538 680.887 309.777 678.934 311.209 677.11C311.975 676.135 312.812 675.222 313.653 674.303C314.41 673.478 314.864 672.507 315.622 671.689C315.667 671.64 315.64 671.431 315.546 671.491C314.528 672.144 313.455 672.626 312.568 673.44C311.631 674.3 310.803 675.287 310.019 676.271C308.469 678.22 307.139 680.322 306.053 682.53C303.868 686.972 302.537 692.033 303.021 696.944C303.048 697.206 303.541 697.489 303.59 697.099Z",
    fill: "#4862AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.685 779.793L254.614 768.654C254.614 768.654 268.977 719.559 271.308 668.454C273.64 617.35 272.24 581.548 272.24 581.548C252.013 572.307 200.121 577.229 149.58 581.548V764.985L176.343 783.399C176.343 783.399 215.656 767.956 222.261 768.654C228.866 769.354 227.685 779.793 227.685 779.793Z",
    fill: "url(#paint16_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.694 585.774C223.36 589.988 221.822 613.356 221.822 613.356L234.18 614.785C239.524 601.489 243.057 601.274 244.854 611.563L247.45 643.472H149.583V581.549C200.124 577.23 252.016 572.308 272.243 581.549C272.243 581.549 272.365 584.694 272.477 590.412C259.591 586.726 245.752 583.834 238.694 585.774Z",
    fill: "#B2D4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.294 779.792C238.015 769.413 246.972 757.25 254.158 729.557C261.343 701.864 265.374 657.861 265.374 635.084C265.374 612.308 266.806 574.547 266.806 574.547C273.758 575.524 279.989 577.439 284.538 581.548C283.337 627.577 284.237 696.599 272.017 745.631C267.279 764.642 259.079 771.483 246.75 777.177C234.421 782.872 225.655 785.718 225.655 785.718L229.294 779.792Z",
    fill: "url(#paint17_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.087 747.96C237.419 728.782 255.741 661.525 255.079 650.988C254.418 640.451 250.18 605.119 244.852 604.189C239.525 603.259 227.71 638.901 226.502 646.65C225.296 654.398 222.664 746.743 222.664 746.743L230.087 747.96Z",
    fill: "url(#paint18_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.67 789.134C175.7 780.864 191.491 766.052 202.225 736.609C212.96 707.165 216.004 691.151 217.617 651.459C219.121 614.41 215.434 571.869 215.434 571.869C186.523 572.835 160.984 575.694 140.769 581.549C140.769 581.549 149.307 640.051 147.367 665.565C145.426 691.08 141.345 774.413 141.345 774.413C141.345 774.413 161.091 778.787 173.67 789.134Z",
    fill: "url(#paint19_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.041 778.787C171.926 773.544 171.712 763.074 171.642 757.838C178.076 751.433 185.139 745.234 191.858 738.969L191.663 739.387C191.934 726.16 192.653 699.537 193.092 686.316C200.234 674.484 208.284 662.896 213.931 650.298C209.075 662.579 200.777 676.016 194.336 686.346C194.071 699.708 193.38 726.31 192.948 739.665C186.389 745.482 178.4 752.976 172.441 757.838C172.371 763.038 172.158 773.584 172.041 778.787Z",
    fill: "#223F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.346 774.413C127.304 771.691 121.059 766.149 111.2 736.909C101.341 707.668 85.2365 646.416 83.5938 632.565L139.946 660.267L155.241 700.588C155.241 700.588 161.303 758.976 141.346 774.413Z",
    fill: "url(#paint20_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.012 661.818C138.741 661.979 136.407 661.852 134.13 661.816C131.656 661.775 129.187 661.69 126.716 661.57C124.467 661.462 122.225 661.307 119.982 661.128C117.561 660.936 115.086 660.759 112.717 660.224C112.409 660.154 112.677 659.612 112.927 659.607C117.637 659.529 122.368 659.977 127.075 660.125C129.292 660.194 131.511 660.245 133.73 660.279C136.203 660.317 138.711 660.183 141.176 660.338C142.254 660.403 141.981 661.749 141.012 661.818Z",
    fill: "#223F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.334 621.158L153.534 608.247C151.081 607.873 148.768 609.432 148.369 611.729L130.089 717.03C129.69 719.326 131.355 721.49 133.808 721.863L218.607 734.775C221.06 735.148 223.373 733.59 223.772 731.292L242.051 625.991C242.452 623.695 240.787 621.532 238.334 621.158Z",
    fill: "#FA5B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.719 663.024C194.912 663.891 199.294 668.317 202.162 674.333C205.868 682.104 203.82 693.225 203.588 696.912C203.355 700.599 208.45 703.853 211.693 698.214C214.935 692.575 217.465 685.205 218.284 681.624C218.284 681.624 225.852 684.549 231.51 685.851C237.168 687.153 240.873 688.573 242.494 683.633C244.114 678.692 238.879 675.005 238.879 675.005C238.879 675.005 240.873 672.836 241.104 668.282C241.336 663.728 239.714 661.992 239.714 661.992C239.714 661.992 243.189 652.015 234.389 644.857C225.588 637.699 192.187 630.976 192.187 630.976L191.719 663.024Z",
    fill: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.188 661.125L192.188 663.512C192.188 663.512 194.556 657.656 195.482 645.943C196.409 634.231 195.482 628.808 195.482 628.808L180.893 626.206L177.188 661.125Z",
    fill: "url(#paint21_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.26 662.422L139.944 660.267L83.592 632.565C81.9493 618.714 86.2207 610.711 103.64 611.634C121.058 612.557 183.832 624.562 183.832 624.562C183.832 624.562 186.55 641.184 180.26 662.422Z",
    fill: "url(#paint22_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.062 581.563V555.82L999.717 555.816C999 563.375 997.143 571.961 994.145 581.561H835.062V581.563Z",
    fill: "#4862AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.455 704.546C800.85 713.254 797.543 715.854 789.575 721.172C780.262 727.388 774.44 731.043 765.579 728.651C756.717 726.259 749.376 724.66 749.756 721.497C750.137 718.334 757.728 718.017 763.277 719.293C756.541 715.346 749.786 713.675 741.207 713.618C732.63 713.561 731.078 712.402 729.733 710.045C728.39 707.688 730.877 705.725 730.877 705.725C728.26 705.777 724.866 705.177 723.846 701.783C723.007 698.996 726.049 696.539 727.802 696.357C725.286 694.064 727.586 689.003 732.146 688.681C731.111 686.315 733.509 682.95 740.489 682.757C749.194 682.518 759.372 684.043 766.953 685.753C780.499 688.81 782.667 685.321 785.233 683.109C790.407 678.648 791.545 678 791.545 678C791.545 678 801.813 679.575 807.636 691.133C813.462 702.69 810.455 704.546 810.455 704.546Z",
    fill: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.147 688.681C734.174 692.442 739.809 692.127 743.651 692.301C747.832 692.417 752.005 692.969 756.114 693.734C754.126 693.065 752.055 692.642 749.979 692.288C745.861 691.445 741.551 691.892 737.424 691.328C735.442 691 733.194 690.455 732.147 688.681Z",
    fill: "#FB929C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.803 696.357C730.724 700.12 736.4 698.892 740.661 699.31C745.19 699.53 749.723 699.862 754.214 700.498C749.817 699.341 745.239 698.95 740.695 698.662C736.359 698.267 731.12 699.7 727.803 696.357Z",
    fill: "#FB929C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.392 705.708C810.109 698.549 804.177 682.681 789.674 679.123C789.674 679.123 825.389 639.41 830.293 633.937C835.197 628.464 840.014 625.453 842.698 625.459C845.381 625.464 845.005 683.191 845.005 683.191L809.392 705.708Z",
    fill: "url(#paint23_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.395 695.266C817.759 692.754 817.068 690.327 816.085 687.91C815.214 685.766 814.12 683.694 812.828 681.746C811.565 679.843 810.108 678.053 808.477 676.411C807.606 675.533 806.671 674.723 805.733 673.909C804.888 673.177 804.324 672.271 803.478 671.546C803.427 671.502 803.43 671.295 803.528 671.344C804.61 671.877 805.724 672.237 806.696 672.945C807.724 673.692 808.656 674.575 809.547 675.46C811.309 677.212 812.872 679.14 814.208 681.196C816.895 685.335 818.818 690.171 818.936 695.054C818.941 695.313 818.49 695.645 818.395 695.266Z",
    fill: "#5586FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.343 581.563C972.228 600.782 961.043 654.349 962.257 663.31C963.74 674.265 977.828 754.493 977.828 754.493L942.217 773.797L941.497 761.659C925.185 752.637 888.852 749.86 872.507 761.659C872.507 761.659 848.813 720.713 848.813 674.304V581.563C878.494 573.63 925.806 576.599 976.343 581.563Z",
    fill: "url(#paint24_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.343 581.563C972.228 600.782 961.043 654.349 962.257 663.31C962.743 666.901 964.583 677.934 966.838 691.147C965.255 688.961 919.348 625.622 906.212 610.357C892.845 594.825 869.793 592.998 848.812 601.677V581.561C878.494 573.63 925.806 576.599 976.343 581.563Z",
    fill: "#B2D4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.145 581.563C986.332 599.476 966.032 646.806 966.287 654.429C966.656 665.482 975.278 696.671 981.407 720.769C987.707 745.536 983.297 753.792 983.297 753.792C983.297 753.792 979.517 756.446 965.341 763.781C951.166 771.118 936.264 777.788 936.264 777.788C916.872 750.237 911.234 715.461 911.234 673.149C911.234 639.775 917.008 588.685 918.788 572.439C943.213 566.8 968.476 571.65 994.145 581.563Z",
    fill: "url(#paint25_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.062 581.563C839.909 579.661 847.023 577.884 855.999 576.21C855.656 596.661 854.98 663.311 858.377 698.054C859.776 712.356 862.726 735.317 880.032 761.176C882.957 765.546 888.399 770.532 890.1 774.509C886.78 771.087 875.12 768.593 875.12 768.593C875.12 768.593 860.196 758.648 847.958 738.661C837.765 722.011 833.654 715.871 832.904 700.442C832.154 685.014 838.523 673.093 838.148 659.895C837.845 649.198 835.818 599.869 835.062 581.563Z",
    fill: "url(#paint26_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.658 587.31C939.836 582.101 936.798 578.942 927.025 580.006C919.946 580.777 911.627 582.031 905.424 582.799C899.221 583.567 895.709 581.05 887.766 573.742C879.825 566.435 869.99 555.128 878.019 550.99C886.048 546.851 895.216 548.276 901.411 550.233C907.607 552.19 909.604 555.12 919.785 549.953C929.966 544.785 940.967 545.766 948.08 549.994C955.193 554.224 964.964 565.129 964.964 565.129C964.964 565.129 961.959 583.594 943.658 587.31Z",
    fill: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.522 759.044C992.722 752.386 1001.59 742.764 1004.25 732.684C1006.73 723.263 1013.12 699.084 1019.85 676.275C1028.58 646.677 1031.44 639.539 1020.89 624.06C1011.42 610.15 965.642 563.859 965.642 563.859C965.642 563.859 954.37 581.686 943.659 587.309C943.659 587.309 975.789 636.301 976.88 643.406C976.448 646.398 959.056 680.747 955.641 696.355C950.881 718.108 955.42 745.047 975.522 759.044Z",
    fill: "url(#paint27_linear_1_4965)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.571 649.053C979.615 647.848 978.991 646.338 978.272 644.997C977.95 644.395 977.628 643.792 977.312 643.187C971.17 656.684 964.319 669.958 959.643 683.987C955.258 697.139 953.051 710.98 955.16 724.71C956.283 732.019 958.699 739.361 962.368 745.902C962.416 745.985 962.345 746.225 962.245 746.088C960.105 743.176 958.21 740.033 956.846 736.728C955.534 733.546 954.597 730.243 953.925 726.891C952.591 720.232 952.414 713.4 953.032 706.659C954.347 692.341 959.426 678.658 965.313 665.482C968.859 657.546 972.746 649.75 976.392 641.856C976.422 641.791 976.469 641.74 976.517 641.69C976.377 641.43 976.245 641.167 976.103 640.908C974.62 638.207 973.054 635.545 971.473 632.893C968.388 627.717 965.18 622.604 962.19 617.379C960.403 614.258 958.696 611.102 957.083 607.9C957.05 607.834 957.122 607.657 957.19 607.763C963.873 618.359 971.218 628.595 977.067 639.635C977.852 641.117 978.628 642.606 979.341 644.119C980.01 645.536 980.787 647.074 981.071 648.606C981.106 648.788 980.793 649.335 980.571 649.053Z",
    fill: "#5586FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.161 588.12C961.911 589.457 960.574 590.735 959.098 591.855C958.329 592.436 957.537 592.989 956.721 593.511C955.955 594 955.175 594.639 954.225 594.664C953.946 594.671 953.623 594.468 953.706 594.17C953.913 593.426 954.723 593.201 955.377 592.824C956.077 592.419 956.761 591.993 957.428 591.544C959.011 590.477 960.535 589.322 961.939 588.055C964.833 585.442 967.216 582.295 969.057 578.952C969.151 578.78 969.291 578.985 969.236 579.109C967.758 582.428 965.689 585.413 963.161 588.12Z",
    fill: "#5586FC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1117 555.856H0V697H1117V555.856Z",
    fill: "url(#paint28_linear_1_4965)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.88 555.816H42.1184C41.3067 555.816 40.6484 555.201 40.6484 554.441C40.6484 553.682 41.3067 553.067 42.1184 553.067H1074.88C1075.69 553.067 1076.35 553.682 1076.35 554.441C1076.35 555.201 1075.69 555.816 1074.88 555.816Z",
    fill: "#9DC4FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.29 553.065C1063.61 523.009 1114.65 346.038 1037.4 225.017C960.157 103.995 843.63 40.7801 683.732 44.0742C567.786 46.4621 455.325 80.1174 377.847 182.062C300.369 284.007 219.712 235.09 103.962 302.586C25.0268 348.614 14.9411 468.781 58.3745 553.065H1055.29Z",
    fill: "url(#paint29_linear_1_4965)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.017 553.065C109.447 523.43 113.565 455.198 73.7698 441.466C33.9748 427.732 16.1356 464.98 32.6017 490.668C49.0692 516.357 85.0202 522.333 87.6281 553.065H106.017Z",
    fill: "url(#paint30_linear_1_4965)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7569 540.065C97.3265 536.573 96.7441 533.093 96.0665 529.636C94.6993 522.661 92.8853 515.762 90.6275 508.993C86.091 495.391 79.797 482.15 71.707 470.062C67.0841 463.157 61.9861 456.509 56.2626 450.361C55.9692 450.046 55.8173 450.558 56.0049 450.785C65.413 462.129 73.6133 474.391 80.0398 487.446C86.3054 500.174 91.0355 513.583 93.9293 527.338C94.738 531.182 95.4067 535.052 95.934 538.939C96.1946 540.868 96.4478 542.797 96.6563 544.732C96.8782 546.799 97.0792 548.858 97.6229 550.874C97.6973 551.15 98.1992 551.383 98.2633 550.979C98.8277 547.42 98.1963 543.621 97.7569 540.065Z",
    fill: "#DEEDFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1092 521.327C28.7442 522.351 30.7518 537.811 45.7077 541.307C59.353 544.498 68.712 543.086 78.2824 553.065H82.8353C78.6324 540.334 66.8875 520.224 47.1092 521.327Z",
    fill: "url(#paint31_linear_1_4965)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9481 549.237C77.9235 546.499 76.038 543.996 74.0512 541.792C72.0734 539.599 69.8349 537.607 67.4028 535.86C62.5833 532.398 56.9998 529.88 51.0812 528.581C47.7957 527.86 44.4522 527.556 41.0982 527.908C40.9865 527.919 40.9776 528.146 41.0923 528.153C47.2402 528.553 53.2408 529.628 58.8555 532.072C64.1769 534.387 68.989 537.734 72.8344 541.89C75.0163 544.247 76.729 546.855 78.5654 549.444C78.762 549.721 79.0598 549.537 78.9481 549.237Z",
    fill: "#DEEDFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.54 553.065C1010.11 523.43 1005.99 455.198 1045.79 441.466C1085.58 427.732 1103.42 464.98 1086.96 490.668C1070.49 516.357 1034.54 522.333 1031.93 553.065H1013.54Z",
    fill: "url(#paint32_linear_1_4965)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.32 541.337C1021.75 537.845 1022.33 534.366 1023.01 530.909C1024.38 523.933 1026.19 517.034 1028.45 510.265C1032.98 496.664 1039.28 483.422 1047.37 471.336C1051.99 464.43 1057.09 457.782 1062.81 451.635C1063.11 451.32 1063.26 451.831 1063.07 452.059C1053.66 463.403 1045.46 475.666 1039.04 488.72C1032.77 501.448 1028.04 514.857 1025.15 528.612C1024.34 532.456 1023.67 536.326 1023.14 540.212C1022.88 542.142 1022.63 544.071 1022.42 546.006C1022.2 548.073 1022 550.132 1021.45 552.148C1021.38 552.424 1020.87 552.657 1020.81 552.252C1020.25 548.691 1020.88 544.892 1021.32 541.337Z",
    fill: "#DEEDFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.45 521.327C1090.81 522.351 1088.81 537.811 1073.85 541.307C1060.21 544.498 1050.85 543.086 1041.28 553.065H1036.72C1040.93 540.334 1052.67 520.224 1072.45 521.327Z",
    fill: "url(#paint33_linear_1_4965)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.61 549.237C1041.64 546.499 1043.52 543.996 1045.51 541.792C1047.49 539.599 1049.72 537.607 1052.16 535.86C1056.98 532.398 1062.56 529.88 1068.48 528.581C1071.76 527.86 1075.11 527.556 1078.46 527.908C1078.57 527.919 1078.58 528.146 1078.47 528.153C1072.32 528.553 1066.32 529.628 1060.7 532.072C1055.38 534.387 1050.57 537.734 1046.72 541.89C1044.54 544.247 1042.83 546.855 1040.99 549.444C1040.8 549.721 1040.5 549.537 1040.61 549.237Z",
    fill: "#DEEDFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M773.301 527.423H632.447V553.066H773.301V527.423Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M744.241 288.982C752.371 276.274 760.536 257.093 760.15 248.999C759.764 240.906 752.757 231.305 736.355 222.997C741.31 220.319 742.915 218.302 738.671 216.495C734.426 214.689 722.462 211.258 705.482 211.438C708.762 206.12 707.219 204.394 698.15 206.38C689.082 208.367 661.047 211.237 665.04 238.486C667.862 257.749 696.607 285.829 716.867 289.637C737.128 293.447 744.241 288.982 744.241 288.982Z",
    fill: "url(#paint34_linear_1_4965)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M675.501 243.42C673.152 243.153 672.162 238.87 672.157 237.34C672.153 235.586 672.124 232.746 672.336 231.557C669.722 233.541 664.602 236.574 661.305 250.152C657.785 264.643 655.235 289.442 658.414 299.394C662.444 312.011 683.978 314.28 693.654 315.175C692.774 324.003 693.529 330.867 687.183 331.117C687.433 340.256 679.82 353.676 693.674 357.36C707.527 361.046 739.203 346.965 743.316 331.739C736.425 329.434 732 327.727 732 317.256C732 311.236 733.147 304.16 733.147 304.16C733.147 304.16 736.504 303.045 740.111 298.175C746.66 289.335 746.546 276.386 737.064 273.185C729.68 270.697 724.452 274.685 721.934 280.272C720.957 282.441 717.965 283.673 716.002 281.773C714.469 280.29 714.757 278.039 714.734 276.151C714.706 273.863 713.512 272.753 711.803 271.214C705.043 265.124 702.665 255.142 706.017 246.94C707.107 244.272 708.728 241.826 710.056 239.255C710.811 237.794 711.464 236.025 710.61 234.613C710.181 233.902 709.434 233.413 708.677 233.006C698.009 227.254 684.222 234.35 677.169 242.185C676.683 242.727 676.247 243.505 675.501 243.42Z",
    fill: "#FBC8C7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M693.654 315.177C701.578 315.04 707.998 313.44 717.113 304.196C715.519 315.224 706.364 321.091 693.202 320.872L693.654 315.177Z",
    fill: "url(#paint35_linear_1_4965)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M690.229 264.171C689.93 265.97 688.448 267.247 686.921 267.025C685.393 266.802 684.398 265.164 684.698 263.364C684.997 261.566 686.479 260.289 688.005 260.511C689.534 260.734 690.53 262.373 690.229 264.171Z",
    fill: "#18185E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M667.047 261.895C666.764 263.598 665.36 264.808 663.914 264.598C662.468 264.387 661.523 262.835 661.808 261.131C662.092 259.428 663.495 258.218 664.941 258.428C666.388 258.639 667.332 260.191 667.047 261.895Z",
    fill: "#18185E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M694.004 258.201C693.85 257.971 693.748 257.731 693.571 257.507C693.312 257.179 693.033 256.859 692.758 256.544C692.086 255.774 691.085 255.182 690.07 254.886C689.438 254.703 688.82 254.609 688.163 254.606C687.495 254.604 686.896 254.731 686.246 254.837C685.751 254.918 685.244 254.729 685.079 254.248C684.917 253.776 685.204 253.343 685.673 253.176C685.211 253.467 685.138 253.498 685.456 253.265C685.527 253.236 685.6 253.205 685.673 253.176C685.777 253.138 685.88 253.109 685.987 253.082C686.194 253.032 686.403 252.992 686.614 252.958C687.078 252.887 687.548 252.841 688.017 252.845C688.962 252.852 689.95 252.994 690.817 253.354C691.985 253.839 693.026 254.701 693.638 255.753C693.824 256.072 693.979 256.38 694.015 256.743C694.06 257.201 694.149 257.741 694.091 258.202C694.083 258.26 694.022 258.227 694.004 258.201Z",
    fill: "#18185E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M660.503 254.695C660.631 253.927 661.054 253.155 661.613 252.59C662.359 251.836 663.301 251.345 664.375 251.136C666.133 250.795 668.017 251.268 669.515 252.145C669.919 252.382 669.996 252.961 669.737 253.313C669.446 253.708 668.922 253.732 668.517 253.499C668.584 253.534 668.65 253.567 668.717 253.601C668.65 253.566 668.584 253.532 668.517 253.499C668.452 253.464 668.389 253.424 668.322 253.39C668.2 253.329 668.073 253.274 667.947 253.221C667.613 253.082 667.265 252.962 666.912 252.87C666.267 252.703 665.568 252.639 664.901 252.688C664.095 252.748 663.226 252.994 662.493 253.316C662.126 253.478 661.766 253.701 661.434 253.923C661.079 254.16 660.865 254.489 660.567 254.77C660.519 254.816 660.499 254.72 660.503 254.695Z",
    fill: "#18185E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M733.147 304.161C726.625 306.075 722.12 303.33 720.919 300.098C720.068 303.683 726.455 308.704 733.147 304.161Z",
    fill: "#FB929C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M739.877 281.79C738.777 279.933 735.925 279.684 733.944 280.151C731.938 280.623 730.136 281.741 728.776 283.19C727.519 284.529 726.649 286.156 726.207 287.886C725.793 289.503 725.559 291.795 726.722 293.189C726.887 293.387 727.303 293.465 727.379 293.153C727.562 292.397 727.365 291.559 727.365 290.79C727.364 290.016 727.461 289.24 727.638 288.484C727.994 286.976 728.727 285.525 729.76 284.319C729.844 284.221 729.942 284.136 730.03 284.043C730.037 284.05 730.04 284.057 730.049 284.064C731.367 285.042 732.528 286.209 733.274 287.634C734.051 289.118 734.276 290.767 734.231 292.4C734.228 292.507 734.398 292.768 734.514 292.601C735.619 291.021 735.253 288.851 734.47 287.221C733.695 285.612 732.446 284.257 731.01 283.13C731.859 282.441 732.824 281.879 733.896 281.539C735.855 280.917 737.693 281.326 739.469 282.21C739.785 282.364 740.044 282.07 739.877 281.79Z",
    fill: "#FB929C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M713.771 271.962C713.731 279.324 710.229 284.093 703.904 287.972C698.924 291.027 692.199 289.873 685.724 286.668C681.044 284.352 676.321 283.71 670.583 283.279C665.775 282.918 659.574 283.984 656.856 286.244C655.523 290.748 655.496 304.883 660.625 309.543C665.755 314.203 675.863 316.604 688.384 316.321C700.906 316.038 711.629 312.515 715.683 306.561C722.731 296.214 720.327 283.627 722.233 279.641L713.771 271.962Z",
    fill: "url(#paint36_linear_1_4965)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M673.883 258.697C673.682 260.111 673.066 261.467 672.592 262.814C672.108 264.191 671.621 265.567 671.149 266.947C670.23 269.641 669.398 272.362 668.631 275.099C668.269 276.393 667.846 277.706 667.615 279.029C667.375 280.407 667.737 281.517 669.121 282.16C670.367 282.739 671.834 283.022 673.206 283.194C673.94 283.286 674.682 283.329 675.423 283.323C675.94 283.321 676.561 283.204 677.05 283.395C677.243 283.471 677.175 283.775 677.011 283.849C676.181 284.223 675.149 284.175 674.25 284.153C672.945 284.121 671.643 283.954 670.386 283.626C668.392 283.106 666.383 282.231 666.4 280.017C666.407 278.998 666.729 277.997 666.991 277.016C667.323 275.769 667.67 274.526 668.038 273.288C668.745 270.911 669.515 268.551 670.339 266.208C671.238 263.647 672.113 260.902 673.599 258.579C673.702 258.42 673.906 258.534 673.883 258.697Z",
    fill: "#FB929C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M683.96 290.855C683.46 290.989 683.018 291.308 682.528 291.488C681.96 291.697 681.366 291.856 680.779 292.009C679.857 292.251 678.892 292.379 677.936 292.429C677.063 292.474 676.183 292.414 675.322 292.276C674.851 292.2 674.406 292.202 674.037 292.529C673.663 292.861 673.9 293.356 674.28 293.59C674.667 293.829 675.268 293.844 675.72 293.893C676.132 293.937 676.548 293.964 676.963 293.971C677.858 293.985 678.759 293.942 679.637 293.773C680.539 293.6 681.428 293.364 682.264 292.995C682.781 292.768 683.297 292.486 683.737 292.145C684.009 291.933 684.47 291.595 684.426 291.227C684.404 291.023 684.202 290.79 683.96 290.855Z",
    fill: "#FB929C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M751.838 240.366C749.658 238.688 747.115 237.407 744.583 236.259C742.114 235.14 739.558 234.189 736.942 233.414C731.82 231.896 726.415 231.005 721.038 230.927C717.985 230.883 714.676 230.902 711.712 231.66C711.55 231.702 711.578 232.024 711.754 232.02C714.363 231.959 716.953 231.681 719.569 231.708C722.245 231.736 724.923 231.907 727.572 232.264C732.973 232.99 738.264 234.43 743.231 236.545C746.175 237.798 748.876 239.407 751.699 240.861C752.058 241.045 752.04 240.522 751.838 240.366Z",
    fill: "#6565C2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M754.656 249.399C747.065 241.407 735.802 236.678 724.546 235.543C722.991 235.387 721.427 235.317 719.863 235.321C718.265 235.325 716.556 235.307 714.999 235.682C714.831 235.723 714.856 236.081 715.032 236.091C716.489 236.169 717.957 236.045 719.417 236.06C720.833 236.074 722.246 236.151 723.657 236.275C726.457 236.52 729.228 236.973 731.946 237.649C737.301 238.983 742.415 241.157 747.01 244.052C749.689 245.74 752.181 247.594 754.54 249.657C754.666 249.769 754.732 249.479 754.656 249.399Z",
    fill: "#6565C2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M746.838 257.771C744.348 253.743 740.714 250.256 736.809 247.42C732.736 244.462 728.134 242.131 723.246 240.593C720.627 239.769 717.842 239.022 715.071 238.906C714.825 238.897 714.885 239.312 715.083 239.355C717.585 239.892 720.093 240.341 722.538 241.088C724.905 241.812 727.209 242.715 729.42 243.783C733.82 245.907 737.825 248.692 741.308 251.982C743.288 253.851 744.996 255.884 746.676 257.985C746.797 258.134 746.901 257.873 746.838 257.771Z",
    fill: "#6565C2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M498.438 447.218C496.495 449.568 494.994 453.75 494.666 458.328C494.201 464.813 495.336 469.594 497.54 475.757C497.54 475.757 499.798 475.821 502.859 475.821C505.919 475.821 507.617 476.409 509.036 476.829C512.815 477.945 513.887 479.022 517.153 481.138C520.093 483.045 543.546 493.904 547.951 494.634C551.929 495.294 553.971 495.833 556.141 495.609C559.371 495.274 564.122 493.79 561.278 489.372C566.623 492.361 572.649 490.596 572.226 485.815C575.09 488.073 580.023 488.357 582.554 485.741C583.646 484.605 583.053 482.378 582.484 481.004C574.108 460.801 569.258 460.976 546.081 451.108C538.436 447.853 532.934 446.122 524.992 445.991C518.355 445.879 502.119 446.473 498.438 447.218Z",
    fill: "#D18080"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M543.797 495.238C544.821 494.775 545.862 494.294 546.653 493.531C547.443 492.767 547.945 491.654 547.649 490.628C546.734 487.462 541.739 487.918 539.166 488.232C539.647 487.78 540.129 487.329 540.61 486.877C541.486 486.056 542.42 485.109 542.429 483.951C542.436 483.064 541.866 482.235 541.102 481.711C540.338 481.187 539.401 480.93 538.469 480.777C537.483 480.615 536.476 480.561 535.475 480.615C535.289 480.625 533.645 480.647 533.613 480.679C534.398 479.886 535.136 479.015 535.5 477.989C536.477 475.239 533.761 473.139 530.959 473.295C529.489 473.378 528.104 473.946 526.783 474.555C522.591 476.489 517.675 478.85 515.193 482.699C514.507 483.764 513.984 485.19 514.817 486.271C515.74 487.469 517.356 488.164 518.879 488.385C520.854 488.672 522.862 488.307 524.822 487.945C523.916 488.879 523.778 490.336 524.31 491.495C525.66 494.441 529.641 494.158 532.501 493.788C532.227 494.6 532.788 495.492 533.563 495.937C536.859 497.828 540.592 496.688 543.797 495.238Z",
    fill: "#FBC8C7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M571.133 445.535C565.201 443.876 559.349 441.791 553.201 441.104C551.375 440.899 549.49 440.825 547.729 441.321C545.812 441.862 544.183 443.038 542.642 444.233C537.493 448.225 532.781 452.711 528.603 457.597C528.357 457.885 528.11 458.179 527.978 458.523C527.677 459.305 528.043 460.215 528.697 460.778C529.349 461.343 530.235 461.612 531.113 461.745C534.82 462.306 538.527 460.692 541.562 458.621C543.321 457.42 545.016 456.024 547.111 455.474C549.588 454.826 552.228 455.47 554.662 456.249C560.785 458.212 566.234 460.541 569.809 463.053C571.515 464.252 574.232 468.108 577.018 472.339C578.807 475.053 582.484 480.998 582.484 480.998L597.348 475.788C596.45 469.12 595.55 462.439 593.971 455.877C593.409 453.534 591.851 446.978 591.851 446.978C591.851 446.978 587.238 447.478 584.507 447.297C580.621 447.043 574.853 446.576 571.133 445.535Z",
    fill: "#FBC8C7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M599.939 441.158L588.6 445.453L596.861 480.89L610.125 476.921L599.939 441.158Z",
    fill: "url(#paint37_linear_1_4965)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M638.861 421.125L596.359 441.105L607.177 481.323L636.854 471.774L638.861 421.125Z",
    fill: "#223F7F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M687.183 331.118L660.503 342.148C660.503 342.148 646.273 390.762 643.963 441.367C641.653 491.972 643.038 527.423 643.038 527.423C667.4 536.215 715.966 531.829 764.57 527.423V345.78L738.053 327.548C738.053 327.548 699.101 342.841 692.557 342.148C686.013 341.455 687.183 331.118 687.183 331.118Z",
    fill: "url(#paint38_linear_1_4965)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M764.569 392.118L702.873 404.986C694.952 451.308 693.127 500.913 687.463 509.012C678.24 522.199 664.154 524.664 642.748 515.409C642.87 523.128 643.036 527.424 643.036 527.424C667.399 536.216 715.965 531.831 764.569 527.424V392.118Z",
    fill: "#B2D4FE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M687.183 331.118C678.542 341.398 669.667 353.44 662.548 380.863C655.429 408.286 651.435 451.857 651.435 474.41C651.435 496.964 650.644 534.662 650.644 534.662L632.449 527.423C633.637 481.843 636.483 412.026 648.59 363.473C653.284 344.648 657.674 339.347 669.889 333.708C682.105 328.07 690.79 325.251 690.79 325.251L687.183 331.118Z",
    fill: "url(#paint39_linear_1_4965)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M692.555 336.448L689.982 335.406C689.982 335.406 683.363 337.52 682.246 343.938C681.131 350.356 683.342 357.956 683.342 357.956L690.698 359.161C690.698 359.161 695.96 351.699 697.714 349.161C699.469 346.624 692.555 336.448 692.555 336.448Z",
    fill: "url(#paint40_linear_1_4965)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M683.343 357.956C676.08 376.947 657.925 443.544 658.582 453.978C659.237 464.413 663.437 499.399 668.715 500.321C673.993 501.241 685.701 465.947 686.896 458.276C688.091 450.604 690.699 359.161 690.699 359.161L683.343 357.956Z",
    fill: "url(#paint41_linear_1_4965)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M689.983 335.406C690.58 331.227 691.576 329.779 692.556 326.485C692.556 324.508 693.087 322.278 693.087 322.278C693.087 322.278 692.16 321.974 690.789 323.323C687.377 326.677 678.94 334.877 677.17 340.186C673.29 351.829 675.379 358.894 675.379 358.894C675.379 358.894 680.94 345.118 689.983 335.406Z",
    fill: "#B2D4FE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M692.555 336.448C692.555 336.448 715.789 334.506 732.151 313.098L732.347 310.625C732.347 310.625 734.612 309.29 735.399 312.536C736.184 315.783 749.232 327.547 749.232 327.547C749.232 327.547 733.988 355.469 698.557 362.536C698.079 349.282 692.555 336.448 692.555 336.448Z",
    fill: "#B2D4FE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M740.701 321.869C738.69 330.057 723.043 344.725 712.408 373.881C701.773 403.036 698.755 418.894 697.157 458.197C695.666 494.884 697.883 536.3 697.883 536.3L773.299 527.423C773.299 527.423 764.839 469.494 766.761 444.227C768.684 418.963 772.727 336.445 772.727 336.445C772.727 336.445 753.165 332.114 740.701 321.869Z",
    fill: "url(#paint42_linear_1_4965)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M742.317 332.114C742.43 337.305 742.643 347.672 742.711 352.858C736.337 359.201 729.337 365.34 722.681 371.543L722.875 371.128C722.607 384.226 721.894 410.588 721.459 423.68C714.384 435.397 706.407 446.871 700.811 459.347C705.623 447.186 713.845 433.88 720.225 423.652C720.488 410.42 721.173 384.079 721.602 370.854C728.101 365.093 736.015 357.674 741.919 352.859C741.989 347.71 742.199 337.267 742.317 332.114Z",
    fill: "#223F7F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M772.729 336.445C783.103 340.911 790.519 350.052 795.045 362.536C799.571 375.021 822.803 447.881 825.518 457.201C828.233 466.52 830.647 474.428 818.579 491.09C806.511 507.752 780.633 553.065 780.633 553.065H732.987C732.987 553.065 756.969 497.717 762.098 487.549C767.227 477.382 768.332 465.602 760.34 443.043C753.196 422.874 749.371 410.352 747.821 400.467C746.271 390.585 751.491 351.015 772.729 336.445Z",
    fill: "#223F7F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M459.038 349.938C472.525 353.604 476.728 361.253 479.764 371.742C482.799 382.232 485.864 402.182 485.864 402.182L459.038 349.938Z",
    fill: "#5586FC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M348.839 296.964C346.009 299.271 343.834 302.08 342.854 305.288C341.677 309.136 341.891 313.239 342.471 317.206C343.038 321.089 343.902 325.248 342.06 328.767C339.583 333.499 333.353 335.109 328.925 338.364C323.78 342.148 321.054 348.62 322.058 354.671C323.124 361.092 327.977 366.695 328.245 373.188C328.519 379.854 326.733 386.835 330.867 392.878C334.968 398.871 341.497 402.18 348.949 403.583C362.112 406.058 370.497 395.698 382.042 392.567C394.192 389.272 407.9 396.059 419.443 389.983C423.675 387.754 426.839 383.816 427.951 379.39C428.882 375.683 428.437 371.705 429.854 368.136C432.215 362.191 438.972 358.968 443.279 354.073C449.403 347.116 450.084 336.848 446.49 328.484C442.897 320.12 435.582 313.53 427.349 308.853C419.116 304.177 409.929 301.209 400.823 298.277C390.39 294.919 379.768 289.92 368.5 289.941C362.1 289.954 354.268 292.537 348.839 296.964Z",
    fill: "url(#paint43_linear_1_4965)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M340.18 376.139C340.48 374.116 340.764 372.049 340.448 370.011C340.213 368.492 339.647 367.05 338.929 365.676C337.346 362.647 335.035 359.918 333.998 356.651C332.869 353.088 333.624 349.116 335.933 346.105C339.509 341.441 345.657 339.357 349.995 335.452C352.192 333.476 353.788 331.045 354.266 328.195C354.789 325.078 354.162 321.908 353.495 318.854C352.716 315.291 351.751 311.597 352.548 307.958C353.519 303.528 357.458 300.714 361.773 299.187C361.919 299.136 361.841 298.766 361.677 298.81C358.218 299.728 354.877 301.626 352.962 304.55C351.133 307.342 350.996 310.592 351.411 313.76C352.25 320.163 355.377 327.272 350.615 332.995C346.702 337.697 340.198 339.665 335.946 344.049C333.477 346.595 332.043 349.876 332.202 353.34C332.369 356.974 334.409 360.029 336.388 363.037C337.501 364.728 338.593 366.459 339.206 368.374C339.979 370.782 339.717 373.28 339.373 375.732C338.827 379.621 338.25 383.948 341.199 387.166C341.482 387.474 341.623 386.97 341.445 386.752C338.992 383.734 339.666 379.625 340.18 376.139ZM361.713 322.374C360.319 318.023 359.171 312.637 362.361 308.708C362.41 308.649 362.362 308.48 362.281 308.568C359.466 311.547 359.583 315.625 360.376 319.311C361.363 323.906 363.844 328.591 362.832 333.372C361.241 340.879 351.609 342.4 347.779 348.458C344.906 353.001 346.573 358.46 348.802 362.904C348.875 363.051 348.99 362.885 348.947 362.782C347.241 358.699 346.103 353.691 348.336 349.581C350.001 346.517 353.266 344.593 356.164 342.658C358.991 340.77 361.901 338.65 363.103 335.476C364.722 331.195 363.039 326.514 361.713 322.374Z",
    fill: "#9DC4FC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M455.376 272.669C461.828 264.328 466.872 242.222 455.376 230.913C443.88 219.605 431.025 224.146 431.025 224.146C431.025 224.146 417.685 218.016 401.194 219.378C384.701 220.74 366.446 231.029 361.403 241.635C356.451 252.049 354.298 285.859 387.933 304.377L455.376 272.669Z",
    fill: "#4862AA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M435.809 243.291C437.876 241.601 439.659 239.583 441.124 237.407C445.44 240.899 449.776 249.511 452.473 259.815C456.144 273.84 458.319 289.098 458.338 297.616C458.353 304.412 457.852 306.564 457.036 309.379C453.937 320.078 442.448 322.986 433.341 322.954C433.743 333.523 433.913 345.789 440.263 345.631C446.322 357.135 468.245 386.602 454.694 391.165C441.142 395.729 387.912 359.299 382.695 344.373C389.316 338.151 392.258 335.001 390.958 324.6C389.925 316.342 387.933 304.377 387.933 304.377C387.933 304.377 379.61 306.916 372.575 299.04C365.203 290.787 363.825 279.713 373.051 275.913C380.236 272.958 386.898 278.357 389.817 283.77C390.95 285.871 394.026 286.909 395.844 284.888C397.265 283.31 396.812 281.082 396.697 279.199C396.558 276.914 397.669 275.731 399.261 274.084C402.853 270.372 404.269 265.524 402.403 260.735C401.265 257.816 397.652 253.355 399.068 250.119C400.017 247.95 403.055 247.451 405.553 247.618C413.847 248.173 422.467 249.951 430.392 246.589C432.367 245.751 434.177 244.623 435.809 243.291Z",
    fill: "#D18080"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M433.34 322.954C425.425 323.325 409.625 320.886 400.415 309.011C404.742 325.614 420.607 332.395 433.721 331.335L433.34 322.954Z",
    fill: "url(#paint44_linear_1_4965)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M420.172 275.97C420.603 277.745 422.174 278.926 423.681 278.605C425.188 278.284 426.061 276.586 425.631 274.812C425.2 273.037 423.629 271.858 422.122 272.177C420.616 272.496 419.742 274.196 420.172 275.97Z",
    fill: "#18185E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M445.586 271.656C445.994 273.337 447.482 274.455 448.91 274.151C450.339 273.847 451.165 272.239 450.759 270.558C450.351 268.876 448.863 267.758 447.434 268.062C446.005 268.366 445.178 269.975 445.586 271.656Z",
    fill: "#18185E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M415.971 270.255C416.109 270.015 416.191 269.77 416.352 269.536C416.588 269.193 416.842 268.854 417.092 268.522C417.706 267.712 418.661 267.056 419.654 266.696C420.271 266.473 420.88 266.339 421.535 266.295C422.202 266.25 422.809 266.339 423.465 266.403C423.966 266.452 424.457 266.23 424.587 265.741C424.713 265.26 424.396 264.846 423.915 264.71C424.398 264.972 424.472 264.997 424.139 264.785C424.064 264.76 423.99 264.735 423.915 264.71C423.808 264.679 423.704 264.657 423.595 264.637C423.385 264.599 423.173 264.573 422.96 264.553C422.494 264.512 422.019 264.496 421.552 264.53C420.61 264.597 419.633 264.802 418.795 265.217C417.666 265.775 416.69 266.702 416.156 267.792C415.993 268.122 415.861 268.438 415.852 268.804C415.84 269.264 415.791 269.809 415.883 270.265C415.897 270.319 415.955 270.284 415.971 270.255Z",
    fill: "#18185E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M451.588 262.332C451.404 261.573 450.925 260.83 450.328 260.303C449.529 259.598 448.553 259.17 447.466 259.029C445.689 258.801 443.842 259.394 442.412 260.365C442.027 260.627 441.993 261.209 442.277 261.544C442.596 261.919 443.12 261.909 443.507 261.651C443.443 261.689 443.379 261.728 443.317 261.766C443.381 261.728 443.445 261.689 443.507 261.651C443.57 261.612 443.629 261.569 443.693 261.531C443.809 261.463 443.933 261.4 444.055 261.339C444.378 261.179 444.716 261.037 445.062 260.922C445.693 260.713 446.385 260.606 447.055 260.611C447.862 260.618 448.75 260.809 449.503 261.085C449.88 261.223 450.257 261.423 450.604 261.622C450.975 261.835 451.211 262.15 451.53 262.412C451.581 262.454 451.594 262.358 451.588 262.332Z",
    fill: "#18185E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M383.973 304.763C390.766 304.065 393.716 299.858 393.427 296.445C395.746 299.41 392.051 306.411 383.973 304.763Z",
    fill: "#B55D5D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M372.04 283.84C373.002 281.916 375.829 281.485 377.839 281.824C379.875 282.167 381.755 283.168 383.217 284.525C384.57 285.781 385.556 287.348 386.123 289.046C386.653 290.634 387.055 292.905 385.996 294.37C385.846 294.578 385.436 294.684 385.338 294.375C385.101 293.634 385.235 292.786 385.18 292.018C385.125 291.246 384.972 290.478 384.739 289.735C384.275 288.252 383.436 286.852 382.318 285.715C382.227 285.623 382.123 285.544 382.029 285.457C382.021 285.464 382.02 285.471 382.011 285.478C380.767 286.538 379.695 287.776 379.055 289.246C378.387 290.776 378.285 292.436 378.447 294.062C378.457 294.168 378.307 294.44 378.179 294.281C376.961 292.775 377.168 290.587 377.83 288.911C378.486 287.256 379.632 285.825 380.982 284.608C380.084 283.975 379.08 283.476 377.987 283.205C375.988 282.71 374.184 283.235 372.476 284.231C372.174 284.407 371.894 284.131 372.04 283.84Z",
    fill: "#B55D5D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M437.815 268.634C438.205 270.012 439 271.284 439.653 272.565C440.32 273.872 440.99 275.18 441.644 276.493C442.922 279.057 444.116 281.656 445.247 284.28C445.781 285.521 446.378 286.772 446.787 288.056C447.211 289.395 447.003 290.538 445.717 291.341C444.56 292.064 443.142 292.518 441.805 292.852C441.088 293.03 440.359 293.161 439.623 293.245C439.109 293.303 438.478 293.26 438.019 293.508C437.837 293.607 437.947 293.901 438.119 293.954C438.993 294.226 440.01 294.056 440.899 293.928C442.189 293.742 443.456 293.42 444.66 292.946C446.568 292.194 448.441 291.087 448.126 288.893C447.98 287.883 447.525 286.927 447.134 285.986C446.635 284.789 446.122 283.597 445.589 282.413C444.566 280.14 443.482 277.89 442.347 275.664C441.106 273.231 439.867 270.612 438.078 268.483C437.958 268.335 437.77 268.473 437.815 268.634Z",
    fill: "#B55D5D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M425.342 297.897C425.206 298.322 425.494 298.679 425.695 299.052C425.957 299.54 426.377 299.912 426.81 300.272C427.564 300.897 428.453 301.364 429.364 301.751C431.088 302.483 432.936 302.933 434.82 303.088C435.737 303.163 436.723 303.219 437.639 303.112C438.141 303.053 438.764 302.716 438.95 302.235C439.2 301.585 438.37 300.962 437.743 300.936C436.835 300.897 435.941 300.972 435.028 300.883C434.071 300.789 433.134 300.609 432.205 300.374C431.26 300.134 430.361 299.797 429.467 299.426C428.801 299.15 428.122 298.863 427.486 298.528C427.23 298.393 426.968 298.304 426.709 298.18C426.371 298.019 426.112 297.81 425.753 297.683C425.57 297.619 425.392 297.736 425.342 297.897Z",
    fill: "#B55D5D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M347.186 527.423C342.599 538.508 341.114 553.066 341.114 553.066H497.442V527.423H347.186Z",
    fill: "#223F7F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M388.497 338.824L453.548 383.911L438.61 344.841L454.464 348.811C454.464 348.811 478.853 389.332 484.342 410.734C489.83 432.136 493.488 527.422 493.488 527.422C478.116 540.075 412.39 532.744 351.722 527.422C351.722 527.422 367.925 490.605 369.754 476.909C371.583 463.211 354.51 400.432 351.767 387.877C349.024 375.321 348.109 367.616 351.767 362.765C355.423 357.915 388.497 338.824 388.497 338.824Z",
    fill: "url(#paint45_linear_1_4965)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M493.175 519.933C478.049 525.107 457.775 524.687 455.059 520.235C451.588 514.551 455.059 500.337 455.059 500.337L491.41 484.595C491.084 478.863 490.724 472.901 490.329 466.937L412.809 474.351L369.742 471.19C369.919 473.538 369.94 475.496 369.753 476.909C367.924 490.606 351.721 527.422 351.721 527.422C412.389 532.744 478.115 540.075 493.486 527.422C493.486 527.422 493.379 524.643 493.175 519.933Z",
    fill: "#B2D4FE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M388.497 338.824C388.497 338.824 413.579 364.376 427.856 391.557C440.178 415.016 442.68 420.815 445.888 462.839C449.095 504.862 447.448 540.244 447.448 540.244C409.336 542.842 375.248 539.547 347.186 527.422C347.186 527.422 357.631 493.49 361.55 479.482C365.47 465.474 360.837 447.749 354.068 423.093C347.298 398.437 343.735 373.258 344.447 367.254C345.159 361.251 361.75 355.555 388.497 338.824Z",
    fill: "url(#paint46_linear_1_4965)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M438.609 344.841C454.662 361.981 471.703 390.953 475.529 412.114C479.356 433.273 482.485 537.103 482.485 537.103C490.314 534.927 496.222 532.041 497.441 527.423C497.441 527.423 492.989 443.691 490.205 418.95C487.422 394.209 459.035 349.937 459.035 349.937L438.609 344.841Z",
    fill: "url(#paint47_linear_1_4965)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M483.853 448.334L498.967 447.177C498.967 447.177 495.853 453.99 496.283 462.868C496.714 471.747 498.967 477.194 498.967 477.194L484.318 479.854C484.318 479.854 482.054 475.075 481.515 465.087C480.976 455.099 483.853 448.334 483.853 448.334Z",
    fill: "url(#paint48_linear_1_4965)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M347.022 363.578C340.807 369.502 340.212 378.556 347.016 410.447C353.821 442.337 375.923 483.498 379.816 491.699C383.71 499.9 389.55 504.759 407.723 501.114C425.894 497.469 486.576 482.238 486.576 482.238C482.897 471.989 481.791 458.915 483.98 447.658L419.73 455.555C419.73 455.555 409.159 415.963 405.371 403.963C397.981 380.547 374.556 348.699 347.022 363.578Z",
    fill: "url(#paint49_linear_1_4965)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M420.452 454.887C416.626 441.131 412.992 427.306 408.789 413.646C405.014 401.377 400.235 388.954 391.521 378.93C386.907 373.623 381.383 368.929 374.928 365.656C374.855 365.618 374.839 365.786 374.898 365.821C385.819 372.087 393.47 381.984 398.952 392.647C405.386 405.163 408.745 418.837 412.502 432.203C414.607 439.686 416.731 447.165 418.851 454.642C418.877 454.73 418.816 454.819 418.72 454.836C411.814 456.044 404.929 457.352 398.208 459.273C398.068 459.313 398.109 459.61 398.26 459.588C403.763 458.766 409.229 457.738 414.696 456.733C416.598 456.383 418.668 456.04 420.634 455.678C420.636 455.681 420.515 455.11 420.452 454.887Z",
    fill: "#5586FC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M445.041 452.444C443.96 452.456 422.494 454.388 418.722 454.837C418.385 454.878 420.038 455.786 420.308 455.745C421.756 455.522 445.067 452.444 445.041 452.444Z",
    fill: "#5586FC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M469.794 476.895C469.344 474.851 469.005 472.791 468.747 470.719C468.498 468.709 468.339 466.69 468.281 464.668C468.218 462.522 468.474 460.33 468.214 458.198C468.187 457.979 467.824 457.74 467.733 458.05C467.153 460.006 467.289 462.203 467.319 464.22C467.35 466.311 467.481 468.4 467.716 470.478C467.958 472.601 468.328 474.713 468.793 476.803C469.27 478.941 469.804 481.007 470.816 482.984C470.932 483.209 471.13 483.092 471.103 482.875C470.857 480.844 470.233 478.894 469.794 476.895Z",
    fill: "#5586FC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M140.769 527.333L137.861 553.065H284.537V527.333H140.769Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M310.183 401.995C310.183 401.995 325.776 392.424 333.372 388.628C345.483 382.574 348.983 379.874 355.024 381.17C364.097 383.116 371.609 384.256 371.434 387.467C371.26 390.677 363.633 391.435 357.959 390.471C365.006 394.059 371.921 395.353 380.567 394.915C389.213 394.476 390.851 395.555 392.361 397.852C393.87 400.149 391.493 402.272 391.493 402.272C394.126 402.069 397.584 402.476 398.837 405.84C399.866 408.6 396.963 411.254 395.21 411.537C397.895 413.703 395.913 418.938 391.341 419.526C392.54 421.851 390.346 425.382 383.327 425.979C374.574 426.724 364.219 425.777 356.47 424.49C342.622 422.193 342.107 424.196 337.531 427.083C331.644 430.798 328.705 432.578 328.705 432.578C328.705 432.578 321.759 432.737 315.13 421.423C308.501 410.108 310.183 401.995 310.183 401.995Z",
    fill: "#FBC8C7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M306.459 403.338L321.015 394.904C321.015 394.904 321.015 404.416 326.88 414.322C332.745 424.228 340.598 426.408 340.598 426.408L327.404 434.917C327.404 434.917 309.6 425.699 306.459 403.338Z",
    fill: "url(#paint50_linear_1_4965)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M391.339 419.523C389.049 415.85 383.395 416.494 379.511 416.539C375.292 416.663 371.052 416.349 366.862 415.815C368.909 416.374 371.024 416.681 373.138 416.918C377.343 417.53 381.654 416.829 385.85 417.159C387.868 417.378 390.169 417.797 391.339 419.523Z",
    fill: "#FB929C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M395.211 411.535C392.02 407.911 386.385 409.478 382.064 409.302C377.486 409.343 372.899 409.27 368.333 408.89C372.838 409.801 377.476 409.93 382.072 409.957C386.465 410.104 391.648 408.357 395.211 411.535Z",
    fill: "#FB929C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M391.493 402.271C384.924 401.969 375.245 401.875 368.776 401.385C376.207 402.806 383.951 402.816 391.493 402.271Z",
    fill: "#FB929C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M312.831 399.415C311.228 406.52 318.633 427.969 332.736 433.106C332.736 433.106 289.691 467.066 284.099 472.025C278.508 476.985 273.307 479.486 270.616 479.191C267.925 478.895 274.835 418.343 274.835 418.343L312.831 399.415Z",
    fill: "#223F7F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M303.59 411.784C303.917 414.372 304.31 416.883 304.998 419.413C305.609 421.657 306.449 423.854 307.505 425.95C308.537 427.996 309.776 429.949 311.209 431.772C311.974 432.748 312.811 433.661 313.653 434.58C314.41 435.405 314.864 436.375 315.622 437.194C315.667 437.242 315.64 437.451 315.546 437.392C314.527 436.739 313.455 436.257 312.567 435.443C311.63 434.581 310.802 433.596 310.019 432.612C308.469 430.663 307.139 428.561 306.053 426.352C303.868 421.91 302.537 416.85 303.021 411.938C303.047 411.676 303.54 411.393 303.59 411.784Z",
    fill: "#4862AA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M170.665 286.869C175.884 289.567 182.306 291.458 187.715 289.112C190.153 288.055 192.109 286.244 194.012 284.468C196.1 282.519 198.19 280.569 200.272 278.615C215.735 264.102 232.315 249.374 241.708 230.603C243.52 226.98 245.309 223.318 246.378 219.445C247.361 215.888 247.854 211.855 246.827 208.251C245.997 205.338 243.017 205.007 240.144 205.525C237.381 206.022 234.903 207.401 232.489 208.754C232.994 206.422 233.998 204.19 234.318 201.829C234.638 199.468 234.112 196.8 232.124 195.319C229.536 193.393 225.774 194.229 222.624 195.167C199.984 201.909 176.803 209.516 159.273 224.533C157.315 226.212 155.414 228 154.081 230.15C150.036 236.667 151.952 244.886 154.275 252.104C157.425 261.891 161.123 271.522 165.347 280.948C166.626 283.802 167.773 285.373 170.665 286.869Z",
    fill: "#D18080"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M225.268 227.695C225.642 227.308 226.009 226.915 226.369 226.518C227.583 225.177 228.786 223.729 230.492 222.994C237.386 220.025 241.458 232.688 243.011 236.77C244.855 241.615 246.001 246.666 247.004 251.713C248.255 258.015 250.112 269.225 250.175 277.314C250.236 285.211 249.618 293.098 247.395 298.559C243.327 308.555 232.206 310.546 224.445 310.749C224.466 313.084 224.504 317.351 224.504 317.351C224.504 323.419 228.055 325.254 230.506 326.506C230.253 335.735 227.419 342.916 213.437 346.638C199.455 350.36 169.654 345.057 165.502 329.681C174.228 324.985 180.633 322.933 180.633 314.429C180.633 308.35 180.258 294.738 180.258 294.738C180.258 294.738 172.099 295.748 166.568 286.867C160.724 277.484 160.073 264.861 169.643 261.63C177.096 259.117 182.373 263.145 184.913 268.788C185.899 270.978 188.918 272.223 190.901 270.305C192.447 268.806 192.158 266.534 192.18 264.629C192.198 263.196 192.993 262.097 193.762 260.925C195.954 257.585 197.652 252.427 197.711 248.529C197.753 245.739 197.311 242.942 196.407 240.284C204.269 238.98 212.307 237.292 218.873 233.038C221.229 231.511 223.344 229.684 225.268 227.695Z",
    fill: "#FBC8C7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M224.447 310.748C214.274 310.342 195.612 305.941 188.406 293.691C192.139 311.239 211.223 317.572 224.506 317.351L224.447 310.748Z",
    fill: "url(#paint51_linear_1_4965)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M180.259 294.738C183.174 294.197 184.727 292.073 185.938 288.806C186.799 292.428 183.315 295.565 180.259 294.738Z",
    fill: "#FB929C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M169.037 271.173C170.148 269.297 173.026 269.046 175.026 269.517C177.052 269.994 178.87 271.125 180.242 272.587C181.511 273.939 182.388 275.583 182.835 277.331C183.252 278.965 183.488 281.277 182.313 282.687C182.147 282.886 181.727 282.965 181.651 282.65C181.466 281.888 181.664 281.042 181.665 280.264C181.667 279.482 181.57 278.698 181.39 277.936C181.031 276.412 180.291 274.947 179.248 273.729C179.163 273.631 179.064 273.545 178.976 273.45C178.967 273.457 178.965 273.464 178.956 273.471C177.626 274.459 176.454 275.637 175.702 277.076C174.917 278.576 174.691 280.24 174.736 281.889C174.739 281.996 174.567 282.26 174.45 282.093C173.334 280.497 173.704 278.305 174.496 276.659C175.278 275.033 176.539 273.666 177.987 272.527C177.129 271.831 176.156 271.264 175.074 270.92C173.097 270.292 171.242 270.704 169.45 271.597C169.131 271.753 168.869 271.456 169.037 271.173Z",
    fill: "#FB929C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M212.471 261.193C212.863 262.994 214.419 264.219 215.947 263.928C217.477 263.636 218.398 261.94 218.007 260.139C217.615 258.338 216.059 257.112 214.531 257.404C213.003 257.695 212.079 259.39 212.471 261.193Z",
    fill: "#18185E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M238.011 257.89C238.382 259.596 239.857 260.756 241.304 260.48C242.754 260.204 243.626 258.597 243.255 256.891C242.885 255.184 241.41 254.025 239.962 254.301C238.515 254.577 237.641 256.184 238.011 257.89Z",
    fill: "#18185E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M208.369 255.332C208.515 255.094 208.603 254.847 208.771 254.613C209.017 254.271 209.281 253.935 209.543 253.605C210.182 252.801 211.162 252.158 212.171 251.816C212.798 251.605 213.416 251.482 214.079 251.451C214.752 251.421 215.363 251.522 216.024 251.602C216.528 251.662 217.03 251.448 217.173 250.956C217.313 250.474 217.001 250.049 216.52 249.901C217 250.176 217.074 250.202 216.744 249.982C216.669 249.955 216.595 249.928 216.52 249.901C216.413 249.868 216.309 249.843 216.198 249.822C215.987 249.78 215.774 249.748 215.561 249.724C215.092 249.672 214.614 249.647 214.14 249.671C213.189 249.718 212.198 249.905 211.342 250.305C210.189 250.845 209.182 251.761 208.616 252.848C208.445 253.178 208.304 253.495 208.286 253.863C208.263 254.327 208.199 254.876 208.281 255.339C208.293 255.395 208.353 255.361 208.369 255.332Z",
    fill: "#18185E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M244.253 250.342C244.086 249.572 243.621 248.811 243.03 248.267C242.241 247.538 241.265 247.085 240.172 246.921C238.383 246.652 236.507 247.212 235.041 248.161C234.645 248.418 234.596 249.005 234.876 249.349C235.189 249.734 235.717 249.737 236.115 249.484C236.179 249.445 236.24 249.403 236.306 249.367C236.425 249.3 236.55 249.239 236.675 249.18C237.006 249.026 237.35 248.889 237.701 248.782C238.343 248.585 239.043 248.49 239.719 248.511C240.534 248.536 241.425 248.747 242.178 249.041C242.555 249.189 242.93 249.398 243.276 249.607C243.645 249.831 243.876 250.153 244.192 250.425C244.242 250.464 244.259 250.368 244.253 250.342Z",
    fill: "#18185E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M228.778 254.96C229.05 256.378 229.738 257.719 230.282 259.057C230.837 260.424 231.397 261.792 231.941 263.164C233.001 265.841 233.975 268.551 234.884 271.278C235.313 272.568 235.804 273.874 236.102 275.198C236.412 276.578 236.101 277.713 234.738 278.422C233.511 279.061 232.044 279.411 230.671 279.643C229.935 279.768 229.189 279.844 228.441 279.871C227.92 279.89 227.288 279.798 226.804 280.013C226.612 280.098 226.697 280.403 226.867 280.47C227.722 280.81 228.76 280.718 229.665 280.657C230.979 280.569 232.283 280.342 233.535 279.957C235.52 279.345 237.501 278.376 237.376 276.143C237.317 275.116 236.944 274.119 236.632 273.142C236.236 271.898 235.825 270.659 235.392 269.427C234.561 267.06 233.669 264.712 232.721 262.384C231.686 259.84 230.669 257.109 229.058 254.829C228.946 254.673 228.746 254.795 228.778 254.96Z",
    fill: "#FB929C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M217.08 285.427C217.032 285.933 217.482 286.478 217.82 286.851C218.266 287.343 218.931 287.75 219.521 288.07C220.629 288.672 221.852 289.085 223.087 289.39C224.356 289.703 225.684 289.843 226.993 289.869C227.559 289.88 228.125 289.864 228.688 289.823C229.392 289.77 230.21 289.764 230.727 289.24C231.198 288.76 231.028 288.102 230.398 287.825C229.83 287.574 229.114 287.769 228.515 287.805C227.228 287.881 225.945 287.815 224.677 287.602C223.517 287.407 222.412 287.115 221.305 286.736C220.687 286.524 220.063 286.317 219.465 286.059C218.806 285.774 218.172 285.424 217.508 285.165C217.293 285.08 217.1 285.225 217.08 285.427Z",
    fill: "#FB929C"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M227.685 329.089L254.613 340.227C254.613 340.227 268.976 389.322 271.307 440.427C273.64 491.532 272.24 527.334 272.24 527.334C252.013 536.574 200.12 531.652 149.58 527.334V343.896L176.343 325.482C176.343 325.482 215.655 340.925 222.261 340.227C228.866 339.528 227.685 329.089 227.685 329.089Z",
    fill: "url(#paint52_linear_1_4965)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M238.694 523.108C223.36 518.894 221.821 495.527 221.821 495.527L234.18 494.098C239.523 507.394 243.056 507.608 244.854 497.319L247.45 465.411H149.583V527.333C200.123 531.652 252.016 536.574 272.243 527.333C272.243 527.333 272.365 524.189 272.476 518.47C259.591 522.155 245.752 525.049 238.694 523.108Z",
    fill: "#B2D4FE"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M229.293 329.089C238.015 339.468 246.972 351.631 254.158 379.324C261.342 407.017 265.374 451.02 265.374 473.796C265.374 496.572 266.805 534.333 266.805 534.333C273.757 533.356 279.989 531.44 284.537 527.332C283.337 481.302 284.236 412.281 272.016 363.249C267.279 344.237 259.078 337.397 246.75 331.702C234.421 326.008 225.655 323.161 225.655 323.161L229.293 329.089Z",
    fill: "url(#paint53_linear_1_4965)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M220.789 339.201L223.386 338.148C223.386 338.148 230.066 340.283 231.193 346.765C232.319 353.245 230.086 360.921 230.086 360.921L222.664 362.139C222.664 362.139 217.353 354.603 215.582 352.041C213.811 349.479 220.789 339.201 220.789 339.201Z",
    fill: "url(#paint54_linear_1_4965)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M230.086 360.922C237.418 380.101 255.74 447.357 255.079 457.894C254.418 468.432 250.179 503.764 244.852 504.694C239.524 505.623 227.709 469.982 226.502 462.232C225.295 454.485 222.664 362.139 222.664 362.139L230.086 360.922Z",
    fill: "url(#paint55_linear_1_4965)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M223.386 338.15C222.784 333.93 225.493 325.883 224.505 322.557C224.505 320.56 224.505 318.308 224.505 318.308C224.505 318.308 225.44 318.001 226.825 319.363C230.268 322.749 234.532 337.615 236.318 342.977C240.233 354.736 238.126 361.87 238.126 361.87C238.126 361.87 232.513 347.958 223.386 338.15Z",
    fill: "#B2D4FE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M220.789 339.201C220.789 339.201 197.339 337.241 180.825 315.621L180.627 313.125C180.627 313.125 179.242 312.288 176.646 316.264C174.774 319.133 163.586 330.214 163.586 330.214C163.586 330.214 178.971 358.412 214.732 365.549C215.216 352.164 220.789 339.201 220.789 339.201Z",
    fill: "#B2D4FE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M173.669 319.749C175.699 328.018 191.491 342.831 202.224 372.274C212.96 401.718 216.004 417.732 217.617 457.423C219.121 494.473 215.433 537.014 215.433 537.014C186.522 536.048 160.983 533.189 140.769 527.334C140.769 527.334 149.307 468.832 147.366 443.317C145.426 417.803 141.345 334.47 141.345 334.47C141.345 334.47 161.091 330.095 173.669 319.749Z",
    fill: "url(#paint56_linear_1_4965)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M172.04 330.095C172.171 335.338 172.357 345.808 172.439 351.044C178.412 355.926 186.377 363.391 192.946 369.216C193.376 382.57 194.073 409.182 194.334 422.537C200.778 432.869 209.065 446.291 213.929 458.584C208.28 445.987 200.23 434.398 193.091 422.566C192.648 409.337 191.935 382.723 191.661 369.495L191.856 369.913C185.139 363.649 178.074 357.448 171.64 351.044C171.725 345.845 171.912 335.299 172.04 330.095Z",
    fill: "#223F7F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M141.345 334.468C127.304 337.191 121.059 342.732 111.2 371.972C101.34 401.213 85.236 462.465 83.5933 476.316L139.945 448.615L155.241 408.293C155.241 408.293 161.302 349.905 141.345 334.468Z",
    fill: "url(#paint57_linear_1_4965)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M141.011 447.064C138.74 446.904 136.406 447.031 134.129 447.067C131.655 447.108 129.186 447.193 126.715 447.313C124.466 447.421 122.225 447.576 119.982 447.755C117.56 447.947 115.085 448.124 112.717 448.659C112.409 448.729 112.677 449.271 112.927 449.275C117.636 449.353 122.368 448.906 127.074 448.758C129.292 448.688 131.511 448.637 133.73 448.603C136.202 448.566 138.71 448.7 141.175 448.545C142.253 448.478 141.981 447.133 141.011 447.064Z",
    fill: "#223F7F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M158.458 382.733C158.056 373.539 156.711 364.271 153.616 355.509C151.841 350.485 149.572 345.624 146.731 341.048C146.579 340.804 146.428 341.13 146.516 341.296C155.266 357.854 157.591 376.627 156.84 394.895C156.626 400.138 156.2 405.38 155.863 410.616C155.842 410.946 156.542 411.411 156.635 410.943C158.461 401.681 158.869 392.134 158.458 382.733Z",
    fill: "#223F7F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M238.333 487.725L153.533 500.636C151.081 501.009 148.768 499.451 148.368 497.154L130.088 391.852C129.689 389.556 131.354 387.393 133.807 387.019L218.607 374.108C221.06 373.734 223.373 375.293 223.772 377.59L242.051 482.892C242.451 485.188 240.786 487.351 238.333 487.725Z",
    fill: "#FA5B7E"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M191.719 445.859C194.912 444.992 199.294 440.564 202.162 434.549C205.867 426.779 203.82 415.658 203.587 411.97C203.355 408.283 208.45 405.03 211.692 410.668C214.934 416.307 217.465 423.677 218.284 427.258C218.284 427.258 225.851 424.332 231.509 423.032C237.167 421.73 240.873 420.309 242.493 425.25C244.114 430.19 238.879 433.877 238.879 433.877C238.879 433.877 240.873 436.046 241.104 440.6C241.334 445.155 239.714 446.89 239.714 446.89C239.714 446.89 243.189 456.867 234.388 464.025C225.588 471.182 192.186 477.907 192.186 477.907L191.719 445.859Z",
    fill: "#FBC8C7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M177.187 447.757L192.188 445.372C192.188 445.372 194.556 451.228 195.482 462.941C196.408 474.653 195.482 480.076 195.482 480.076L180.892 482.678L177.187 447.757Z",
    fill: "url(#paint58_linear_1_4965)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M180.26 446.461L139.943 448.616L83.5916 476.318C81.9488 490.168 86.2202 498.171 103.639 497.249C121.057 496.326 183.831 484.321 183.831 484.321C183.831 484.321 186.549 467.699 180.26 446.461Z",
    fill: "url(#paint59_linear_1_4965)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M835.062 527.32V553.063L999.717 553.067C999 545.507 997.143 536.921 994.145 527.321L835.062 527.32Z",
    fill: "#4862AA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M810.455 404.337C800.85 395.628 797.543 393.029 789.575 387.711C780.262 381.495 774.44 377.84 765.579 380.232C756.717 382.624 749.376 384.223 749.756 387.386C750.137 390.549 757.728 390.865 763.277 389.59C756.541 393.536 749.786 395.207 741.207 395.265C732.63 395.322 731.078 396.48 729.733 398.837C728.39 401.195 730.877 403.157 730.877 403.157C728.26 403.106 724.866 403.705 723.846 407.1C723.007 409.886 726.049 412.344 727.802 412.525C725.286 414.818 727.586 419.88 732.146 420.202C731.111 422.567 733.509 425.933 740.489 426.125C749.194 426.365 759.372 424.84 766.953 423.129C780.499 420.072 782.667 423.561 785.233 425.774C790.407 430.233 791.545 430.883 791.545 430.883C791.545 430.883 801.813 429.307 807.636 417.75C813.462 406.192 810.455 404.337 810.455 404.337Z",
    fill: "#FBC8C7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M732.147 420.2C734.174 416.439 739.809 416.755 743.651 416.58C747.832 416.463 752.005 415.913 756.114 415.147C754.126 415.816 752.055 416.239 749.979 416.593C745.861 417.436 741.551 416.989 737.424 417.553C735.442 417.882 733.194 418.427 732.147 420.2Z",
    fill: "#FB929C"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M727.803 412.525C730.724 408.761 736.4 409.991 740.661 409.573C745.19 409.352 749.723 409.021 754.214 408.385C749.817 409.542 745.239 409.932 740.695 410.221C736.359 410.614 731.12 409.181 727.803 412.525Z",
    fill: "#FB929C"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M730.88 403.158C737.357 402.486 746.923 401.844 753.288 400.991C746.032 402.819 738.373 403.268 730.88 403.158Z",
    fill: "#FB929C"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M809.392 403.173C810.109 410.332 804.177 426.2 789.674 429.758C789.674 429.758 825.389 469.471 830.293 474.944C835.197 480.417 840.014 483.428 842.698 483.423C845.381 483.417 845.005 425.69 845.005 425.69L809.392 403.173Z",
    fill: "url(#paint60_linear_1_4965)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M818.395 413.617C817.759 416.129 817.068 418.556 816.085 420.973C815.214 423.115 814.12 425.188 812.828 427.137C811.565 429.041 810.108 430.831 808.477 432.472C807.606 433.35 806.671 434.16 805.733 434.974C804.888 435.706 804.324 436.612 803.478 437.337C803.427 437.38 803.43 437.588 803.528 437.539C804.61 437.005 805.724 436.646 806.696 435.937C807.724 435.19 808.656 434.308 809.547 433.423C811.309 431.67 812.872 429.742 814.208 427.686C816.895 423.548 818.818 418.712 818.936 413.829C818.941 413.568 818.49 413.237 818.395 413.617Z",
    fill: "#5586FC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M875.12 340.288C859.275 343.341 850.811 347.428 845.993 358.566C841.177 369.703 835.291 394.011 835.291 394.011L875.12 340.288Z",
    fill: "#5586FC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M937.512 231.351C937.239 225.662 923.564 208.361 896.217 213.813C868.87 219.265 855.597 232.762 852.812 249.59C850.027 266.419 867.145 276.469 867.145 276.469C888.629 281.177 904.371 293.822 918.655 308.966C920.013 310.406 922.222 313.026 924.443 313.276C926.701 313.532 929.635 311.066 931.463 309.952C936.444 306.917 941.159 303.5 945.542 299.743C948.845 296.912 951.976 293.872 954.524 290.423C959.637 283.502 962.238 275.05 962.248 266.636C962.261 255.103 958.282 241.161 947.411 234.907C942.169 231.889 937.509 231.288 937.512 231.351Z",
    fill: "#D18080"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M882.257 238.296C881.824 238.014 881.34 237.816 880.813 237.738C878.862 237.453 876.026 238.742 874.599 239.983C873.296 241.116 872.329 242.553 871.536 244.03C869.117 248.522 867.967 253.638 866.855 258.523C864.831 267.406 863.222 286.636 863.946 294.993C864.524 301.66 865.201 303.733 866.247 306.431C870.219 316.689 881.742 318.666 890.674 317.938C890.87 321.837 891.12 325.967 891.026 329.625C890.87 335.721 887.956 338.993 880.979 339.988C876.039 351.734 868.018 373.312 893.999 374.939C934.494 377.473 938.398 350.124 942.216 335.084C935.181 329.486 932.02 326.621 932.39 316.32C932.683 308.141 933.596 296.252 933.596 296.252C933.596 296.252 941.981 298.107 948.196 289.845C954.709 281.188 955.096 270.22 945.715 267.196C938.41 264.846 932.347 270.649 929.953 276.182C929.024 278.329 926.099 279.582 924.136 277.738C921.821 275.559 923.744 272.169 922.066 269.851C921.014 268.398 919.711 267.44 918.951 265.733C918.235 264.123 917.864 262.376 917.75 260.64C917.502 256.878 918.308 253.13 918.52 249.364C918.615 247.675 918.575 245.914 917.788 244.392C916.226 241.368 912.154 240.182 908.58 240.472C903.358 240.897 898.808 243.664 894.762 246.582C893.106 247.775 891.956 248.609 889.795 248.496C887.227 248.361 885.964 246.576 885.304 244.411C884.895 243.066 884.671 241.661 884.049 240.39C883.65 239.574 883.036 238.802 882.257 238.296Z",
    fill: "#FBC8C7"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M890.672 317.939C898.468 317.7 913.754 314.102 921.753 301.751C918.955 318.367 903.874 323.669 890.917 323.628L890.672 317.939Z",
    fill: "url(#paint61_linear_1_4965)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M937.512 296.331C930.788 296.164 927.529 292.263 927.514 288.893C925.498 291.978 929.732 298.561 937.512 296.331Z",
    fill: "#FB929C"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M948.037 275.693C946.926 273.879 944.116 273.673 942.172 274.158C940.205 274.65 938.447 275.775 937.132 277.218C935.915 278.552 935.084 280.166 934.676 281.874C934.294 283.471 934.097 285.73 935.264 287.086C935.43 287.278 935.841 287.351 935.911 287.041C936.079 286.295 935.874 285.474 935.86 284.716C935.847 283.954 935.93 283.19 936.094 282.442C936.422 280.952 937.12 279.515 938.12 278.315C938.2 278.217 938.297 278.134 938.38 278.039C938.388 278.046 938.391 278.053 938.4 278.058C939.712 279.005 940.872 280.137 941.627 281.529C942.415 282.981 942.661 284.6 942.641 286.208C942.64 286.312 942.811 286.567 942.923 286.401C943.986 284.832 943.593 282.7 942.796 281.107C942.01 279.533 940.759 278.217 939.33 277.127C940.157 276.437 941.097 275.873 942.147 275.523C944.065 274.886 945.879 275.262 947.641 276.108C947.955 276.26 948.205 275.967 948.037 275.693Z",
    fill: "#FB929C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M900.586 272.062C900.369 273.842 898.967 275.154 897.456 274.992C895.944 274.83 894.896 273.256 895.113 271.476C895.33 269.696 896.732 268.384 898.244 268.546C899.755 268.708 900.804 270.281 900.586 272.062Z",
    fill: "#18185E"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M875.098 269.527C874.892 271.214 873.564 272.456 872.131 272.303C870.698 272.15 869.705 270.658 869.912 268.973C870.119 267.287 871.446 266.044 872.879 266.197C874.312 266.35 875.304 267.842 875.098 269.527Z",
    fill: "#18185E"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M904.043 266.048C903.881 265.828 903.772 265.595 903.588 265.382C903.318 265.069 903.031 264.764 902.746 264.464C902.054 263.732 901.044 263.187 900.031 262.935C899.403 262.779 898.791 262.709 898.144 262.732C897.487 262.754 896.903 262.903 896.269 263.031C895.785 263.129 895.279 262.962 895.095 262.496C894.917 262.039 895.18 261.601 895.635 261.42C895.192 261.724 895.122 261.756 895.425 261.516C895.495 261.484 895.565 261.452 895.635 261.42C895.736 261.378 895.834 261.346 895.94 261.317C896.141 261.259 896.345 261.211 896.551 261.172C897.002 261.084 897.463 261.023 897.925 261.007C898.853 260.978 899.833 261.081 900.701 261.402C901.87 261.835 902.931 262.644 903.579 263.656C903.775 263.962 903.941 264.259 903.991 264.616C904.055 265.065 904.165 265.593 904.128 266.049C904.124 266.102 904.063 266.074 904.043 266.048Z",
    fill: "#18185E"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M868.353 262.691C868.447 261.93 868.829 261.155 869.354 260.579C870.055 259.81 870.961 259.291 872.008 259.046C873.72 258.643 875.595 259.039 877.106 259.845C877.514 260.062 877.613 260.629 877.374 260.985C877.104 261.384 876.592 261.427 876.182 261.213C876.249 261.244 876.316 261.276 876.382 261.307C876.315 261.276 876.248 261.244 876.182 261.213C876.117 261.181 876.053 261.145 875.986 261.114C875.863 261.059 875.737 261.01 875.61 260.963C875.275 260.837 874.928 260.733 874.578 260.656C873.936 260.515 873.248 260.479 872.593 260.553C871.804 260.642 870.958 260.917 870.252 261.262C869.899 261.435 869.553 261.668 869.236 261.898C868.898 262.145 868.701 262.476 868.42 262.764C868.375 262.811 868.35 262.718 868.353 262.691Z",
    fill: "#18185E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M883.917 265.79C883.692 267.177 883.06 268.501 882.569 269.82C882.067 271.167 881.56 272.513 881.07 273.864C880.114 276.5 879.245 279.164 878.439 281.845C878.058 283.113 877.617 284.397 877.365 285.695C877.103 287.047 877.439 288.146 878.789 288.801C880.004 289.392 881.443 289.694 882.789 289.887C883.51 289.99 884.24 290.044 884.97 290.051C885.479 290.057 886.092 289.952 886.569 290.149C886.758 290.227 886.685 290.525 886.521 290.595C885.698 290.947 884.682 290.885 883.799 290.849C882.517 290.796 881.239 290.609 880.007 290.266C878.055 289.721 876.095 288.826 876.153 286.648C876.179 285.646 876.515 284.666 876.79 283.704C877.14 282.483 877.505 281.265 877.891 280.053C878.631 277.727 879.434 275.417 880.289 273.124C881.224 270.619 882.135 267.933 883.641 265.67C883.744 265.513 883.942 265.628 883.917 265.79Z",
    fill: "#FB929C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M897.982 292.859C897.49 293.07 897.116 293.464 896.689 293.772C896.068 294.22 895.431 294.618 894.754 294.987C893.967 295.418 893.179 295.803 892.328 296.118C890.738 296.705 889.119 297.095 887.409 297.208C886.789 297.248 886.334 297.342 885.915 297.824C885.784 297.975 885.69 298.126 885.702 298.326C885.725 298.694 886.107 299.159 886.463 299.297C886.903 299.467 887.525 299.359 887.993 299.317C888.441 299.278 888.888 299.221 889.332 299.147C891.168 298.842 892.9 298.271 894.538 297.439C895.436 296.983 896.282 296.438 897.036 295.792C897.727 295.198 898.971 294.144 898.566 293.164C898.494 292.991 898.192 292.768 897.982 292.859Z",
    fill: "#FB929C"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M976.343 527.32C972.228 508.101 961.043 454.533 962.257 445.573C963.74 434.617 977.828 354.39 977.828 354.39L942.217 335.086L941.497 347.222C925.185 356.244 888.852 359.021 872.507 347.222C872.507 347.222 848.813 388.168 848.813 434.577V527.318C878.494 535.253 925.806 532.284 976.343 527.32Z",
    fill: "url(#paint62_linear_1_4965)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M976.343 527.32C972.228 508.101 961.043 454.533 962.257 445.573C962.743 441.982 964.583 430.948 966.838 417.736C965.255 419.922 919.348 483.261 906.212 498.524C892.845 514.057 869.793 515.883 848.812 507.204V527.32C878.494 535.253 925.806 532.284 976.343 527.32Z",
    fill: "#B2D4FE"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M994.145 527.32C986.332 509.407 966.032 462.076 966.287 454.454C966.656 443.401 975.278 412.211 981.407 388.113C987.707 363.346 983.297 355.091 983.297 355.091C983.297 355.091 979.517 352.437 965.341 345.101C951.166 337.765 936.264 331.094 936.264 331.094C916.872 358.646 911.234 393.422 911.234 435.734C911.234 469.107 917.008 520.198 918.788 536.443C943.213 542.082 968.476 537.232 994.145 527.32Z",
    fill: "url(#paint63_linear_1_4965)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M835.062 527.32C839.909 529.221 847.023 530.998 855.999 532.673C855.656 512.221 854.98 445.571 858.377 410.829C859.776 396.526 862.726 373.566 880.032 347.707C882.957 343.337 888.399 338.35 890.1 334.373C886.78 337.796 875.12 340.288 875.12 340.288C875.12 340.288 860.196 350.233 847.958 370.22C837.765 386.87 833.654 393.01 832.904 408.439C832.154 423.867 838.523 435.788 838.148 448.987C837.845 459.684 835.818 509.014 835.062 527.32Z",
    fill: "url(#paint64_linear_1_4965)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M943.658 521.572C939.836 526.782 936.798 529.94 927.025 528.877C919.946 528.106 911.627 526.851 905.424 526.083C899.221 525.314 895.709 527.833 887.766 535.14C879.825 542.447 869.99 553.754 878.019 557.893C886.048 562.032 895.216 560.607 901.411 558.65C907.607 556.693 909.604 553.763 919.785 558.93C929.966 564.098 940.967 563.116 948.08 558.888C955.193 554.66 964.964 543.754 964.964 543.754C964.964 543.754 961.959 525.289 943.658 521.572Z",
    fill: "#FBC8C7"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M975.522 349.838C992.722 356.496 1001.59 366.119 1004.25 376.199C1006.73 385.62 1013.12 409.798 1019.85 432.607C1028.58 462.206 1031.44 469.343 1020.89 484.822C1011.42 498.733 965.642 545.023 965.642 545.023C965.642 545.023 954.37 527.197 943.659 521.574C943.659 521.574 975.789 472.581 976.88 465.475C976.448 462.483 959.056 428.134 955.641 412.527C950.881 390.775 955.42 363.834 975.522 349.838Z",
    fill: "url(#paint65_linear_1_4965)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M980.571 459.828C979.615 461.033 978.991 462.543 978.272 463.884C977.95 464.486 977.628 465.089 977.312 465.694C971.17 452.197 964.319 438.923 959.643 424.894C955.258 411.742 953.051 397.901 955.16 384.171C956.283 376.862 958.699 369.52 962.368 362.979C962.416 362.896 962.345 362.656 962.245 362.793C960.105 365.705 958.21 368.848 956.846 372.153C955.534 375.334 954.597 378.638 953.925 381.989C952.591 388.649 952.414 395.481 953.032 402.222C954.347 416.54 959.426 430.223 965.313 443.399C968.859 451.335 972.746 459.131 976.392 467.025C976.422 467.09 976.469 467.141 976.517 467.191C976.377 467.451 976.245 467.713 976.103 467.973C974.62 470.674 973.054 473.335 971.473 475.988C968.388 481.164 965.18 486.276 962.19 491.502C960.403 494.623 958.696 497.779 957.083 500.981C957.05 501.047 957.122 501.224 957.19 501.118C963.873 490.522 971.218 480.286 977.067 469.246C977.852 467.764 978.628 466.275 979.341 464.762C980.01 463.345 980.787 461.807 981.071 460.275C981.106 460.093 980.793 459.547 980.571 459.828Z",
    fill: "#5586FC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M963.161 520.761C961.911 519.424 960.574 518.146 959.098 517.026C958.329 516.445 957.537 515.892 956.721 515.37C955.955 514.881 955.175 514.243 954.225 514.217C953.946 514.21 953.623 514.413 953.706 514.711C953.913 515.455 954.723 515.678 955.377 516.056C956.077 516.46 956.761 516.887 957.428 517.336C959.011 518.402 960.535 519.558 961.939 520.825C964.833 523.437 967.216 526.585 969.057 529.926C969.151 530.098 969.291 529.893 969.236 529.769C967.758 526.453 965.689 523.468 963.161 520.761Z",
    fill: "#5586FC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M786.872 568.719L908.535 591.881L963.194 570.712L950.201 568.719H786.872Z",
    fill: "#9DC4FC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M906.076 585.537C908.29 586.517 912.491 585.197 923.43 581.203C937.117 576.206 947.508 572.329 948.98 571.682C951.145 570.73 951.376 570.708 951.376 569.449C951.376 568.968 951.376 568.597 951.376 567.849C951.376 567.849 947.821 566.506 945.605 566.08C939.942 564.991 902.675 557.161 902.675 557.161L906.076 585.537Z",
    fill: "#B2D4FE"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M905.618 582.108C907.067 583.464 908.093 583.97 923.797 578.312C941.555 571.914 947.373 569.811 950.201 568.719C953.011 567.631 950.509 567.149 945.606 566.078C938.213 564.463 902.676 557.159 902.676 557.159L905.618 582.108Z",
    fill: "#DEEDFE"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M787.977 567.654L905.484 586.828C906.678 586.991 907.715 586.052 907.579 584.929L896.635 493.022C896.257 490.025 893.812 487.602 890.627 487.125C855.558 481.858 832.806 478.779 781.455 470.995C777.355 470.373 774.115 473.032 774.68 476.883C776.802 502.152 780.834 536.926 784.76 564.789C785.165 566.827 786.499 567.354 787.977 567.654Z",
    fill: "#B2D4FE"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M786.872 568.719L904.379 587.893C905.573 588.056 906.61 587.117 906.474 585.995L895.53 494.087C895.152 491.09 892.707 488.667 889.522 488.19C854.453 482.924 831.701 479.843 780.35 472.059C776.25 471.437 773.01 474.095 773.575 477.947C775.697 503.217 779.729 537.991 783.655 565.853C784.06 567.892 785.394 568.418 786.872 568.719Z",
    fill: "url(#paint66_linear_1_4965)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M895.53 494.087C895.152 491.09 892.706 488.667 889.522 488.189C882.369 487.114 874.103 485.901 866.802 484.821C875.125 487.022 882.622 488.377 885.58 494.402C890.472 504.365 884.96 542.793 849.048 559.889C814.846 576.171 789.101 564.333 781.687 551.365C782.339 556.332 782.998 561.194 783.654 565.851C784.059 567.891 785.394 568.416 786.87 568.717L904.377 587.892C904.526 587.913 904.673 587.915 904.815 587.903C905.242 587.867 905.629 587.691 905.923 587.425C906.314 587.071 906.539 586.555 906.471 585.993L895.53 494.087Z",
    fill: "#EBF7FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M844.774 530.483C845.728 535.62 842.517 539.783 837.601 539.783C832.685 539.783 827.925 535.62 826.97 530.483C826.016 525.346 829.227 521.182 834.143 521.182C839.061 521.182 843.819 525.347 844.774 530.483Z",
    fill: "#CBE3FE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1465 181.896C42.1465 184.719 44.5905 187.008 47.6079 187.008H145.832C143.485 178.588 135.289 172.365 125.555 172.365C123.612 172.365 121.731 172.621 119.945 173.082V161.593C119.945 156.103 117.571 151.124 113.719 147.527C109.877 143.922 104.557 141.7 98.692 141.7C86.9531 141.7 77.4377 150.605 77.4377 161.594V167.857C74.9848 166.343 72.0478 165.462 68.8815 165.462C61.4602 165.462 55.2601 170.302 53.6516 176.787H47.6079C44.592 176.786 42.1465 179.073 42.1465 181.896Z",
    fill: "#EBF7FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.41 162.083C1035.41 164.898 1032.97 167.178 1029.96 167.178H932.046C934.386 158.785 942.556 152.582 952.259 152.582C954.197 152.582 956.072 152.837 957.852 153.295V148.122C957.852 142.649 960.218 137.685 964.058 134.1C967.888 130.506 973.192 128.291 979.039 128.291C990.741 128.291 1000.23 137.168 1000.23 148.122V148.086C1002.67 146.576 1005.6 145.698 1008.76 145.698C1016.15 145.698 1022.33 150.523 1023.94 156.988H1029.96C1032.97 156.988 1035.41 159.269 1035.41 162.083Z",
    fill: "#EBF7FF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M214.757 125.276C214.757 127.419 212.902 129.156 210.613 129.156H138.106C139.889 122.764 146.11 118.041 153.498 118.041C154.974 118.041 156.402 118.235 157.756 118.585V114.853C157.756 110.686 159.558 106.906 162.482 104.175C165.399 101.439 169.437 99.752 173.89 99.752C182.801 99.752 190.024 106.511 190.024 114.853V114.618C191.886 113.468 194.115 112.8 196.519 112.8C202.153 112.8 206.858 116.473 208.081 121.397H210.613C212.902 121.397 214.757 123.134 214.757 125.276Z",
    fill: "#EBF7FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M383.996 136.105C383.996 105.098 352.839 79.9612 314.407 79.9612C275.975 79.9612 244.816 105.098 244.816 136.105C244.816 160.173 263.595 180.696 289.973 188.679C289.586 196.048 283.843 203.758 274.783 207.107C274.101 207.359 274.287 208.234 275.028 208.275C289.916 209.101 301.448 207.751 316.495 192.205C353.959 191.31 383.996 166.545 383.996 136.105Z",
    fill: "#40C9E2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M734.211 136.659C734.211 105.346 765.657 79.9626 804.447 79.9626C843.237 79.9626 874.682 105.347 874.682 136.659C874.682 160.967 855.729 181.691 829.107 189.754C829.499 197.195 835.294 204.982 844.437 208.363C845.127 208.618 844.939 209.5 844.19 209.542C829.164 210.377 817.523 209.012 802.336 193.313C764.525 192.411 734.211 167.401 734.211 136.659Z",
    fill: "#FA5B7E"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M572.902 133.591C572.902 102.584 541.745 77.4492 503.313 77.4492C464.88 77.4492 433.724 102.586 433.724 133.591C433.724 157.66 452.503 178.182 478.88 186.166C478.493 193.535 472.75 201.245 463.691 204.593C463.008 204.845 463.193 205.721 463.935 205.761C478.824 206.588 490.356 205.237 505.402 189.691C542.866 188.798 572.902 164.033 572.902 133.591Z",
    fill: "#FECA58"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M530.234 164.697C530.234 133.69 561.391 108.553 599.823 108.553C638.257 108.553 669.412 133.69 669.412 164.697C669.412 188.766 650.633 209.288 624.256 217.272C624.643 224.64 630.386 232.35 639.445 235.699C640.127 235.951 639.941 236.827 639.199 236.867C624.311 237.694 612.779 236.343 597.732 220.797C560.271 219.903 530.234 195.138 530.234 164.697Z",
    fill: "#5586FC"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M572.9 133.591C572.9 155.587 557.218 174.618 534.383 183.828C531.693 177.865 530.235 171.419 530.235 164.702C530.235 142.695 545.918 123.652 568.752 114.454C571.43 120.429 572.9 126.875 572.9 133.591Z",
    fill: "#40C9E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4965",
    x1: 556.198,
    y1: 1045.83,
    x2: 556.198,
    y2: 569.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6906,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9285,
    stopColor: "#E4F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEDFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4965",
    x1: 52.6292,
    y1: 665.408,
    x2: 87.7643,
    y2: 555.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5586FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4965",
    x1: 50.6,
    y1: 587.846,
    x2: 62.3473,
    y2: 551.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5586FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_4965",
    x1: 1066.93,
    y1: 665.408,
    x2: 1031.79,
    y2: 555.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5586FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_4965",
    x1: 1068.96,
    y1: 587.846,
    x2: 1057.21,
    y2: 551.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5586FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_4965",
    x1: 600.702,
    y1: 631.603,
    x2: 598.288,
    y2: 664.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_4965",
    x1: 714.718,
    y1: 761.8,
    x2: 702.778,
    y2: 584.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_4965",
    x1: 660.576,
    y1: 783.358,
    x2: 662.782,
    y2: 539.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_4965",
    x1: 658.564,
    y1: 679.735,
    x2: 690.698,
    y2: 679.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_4965",
    x1: 733.772,
    y1: 783.703,
    x2: 735.987,
    y2: 538.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_4965",
    x1: 422.021,
    y1: 757.419,
    x2: 421.169,
    y2: 598.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_4965",
    x1: 405.337,
    y1: 768.839,
    x2: 390.908,
    y2: 569.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_4965",
    x1: 438.61,
    y1: 667.91,
    x2: 497.442,
    y2: 667.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_4965",
    x1: 481.448,
    y1: 645.367,
    x2: 498.966,
    y2: 645.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_4965",
    x1: 342.135,
    y1: 677.829,
    x2: 486.576,
    y2: 677.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_4965",
    x1: 327.324,
    y1: 676.986,
    x2: 319.941,
    y2: 713.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_4965",
    x1: 216.66,
    y1: 772.575,
    x2: 207.282,
    y2: 587.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_4965",
    x1: 256.148,
    y1: 785.443,
    x2: 253.924,
    y2: 539.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_4965",
    x1: 255.097,
    y1: 676.065,
    x2: 222.664,
    y2: 676.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_4965",
    x1: 180.562,
    y1: 789.071,
    x2: 178.601,
    y2: 572.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_4965",
    x1: 151.313,
    y1: 776.803,
    x2: 107.149,
    y2: 615.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_4965",
    x1: 184.964,
    y1: 628.138,
    x2: 187.29,
    y2: 660.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_4965",
    x1: 177.776,
    y1: 769.529,
    x2: 133.618,
    y2: 608.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_4965",
    x1: 789.676,
    y1: 665.584,
    x2: 845.023,
    y2: 665.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_4965",
    x1: 917.056,
    y1: 759.068,
    x2: 911.942,
    y2: 589.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_4965",
    x1: 911.236,
    y1: 673.917,
    x2: 997.158,
    y2: 673.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_4965",
    x1: 832.843,
    y1: 675.359,
    x2: 890.1,
    y2: 675.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_4965",
    x1: 936.284,
    y1: 658.402,
    x2: 1012.01,
    y2: 666.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_4965",
    x1: 558.5,
    y1: 558.88,
    x2: 558.5,
    y2: 676.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_4965",
    x1: 556.198,
    y1: 63.0484,
    x2: 556.198,
    y2: 538.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6906,
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9285,
    stopColor: "#E4F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEDFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_4965",
    x1: 52.6292,
    y1: 443.474,
    x2: 87.7643,
    y2: 553.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5586FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_4965",
    x1: 50.6,
    y1: 521.036,
    x2: 62.3473,
    y2: 557.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5586FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_4965",
    x1: 1066.93,
    y1: 443.474,
    x2: 1031.79,
    y2: 553.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5586FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_4965",
    x1: 1068.96,
    y1: 521.036,
    x2: 1057.21,
    y2: 557.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5586FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_4965",
    x1: 692.672,
    y1: 203.256,
    x2: 737.181,
    y2: 306.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6565C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#313180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_4965",
    x1: 710.113,
    y1: 318.276,
    x2: 703.546,
    y2: 309.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#FB929C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_4965",
    x1: 655.142,
    y1: 221.401,
    x2: 698.966,
    y2: 323.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6565C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#313180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_4965",
    x1: 600.702,
    y1: 477.28,
    x2: 598.288,
    y2: 444.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_4965",
    x1: 714.718,
    y1: 347.082,
    x2: 702.778,
    y2: 524.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_4965",
    x1: 660.576,
    y1: 325.524,
    x2: 662.782,
    y2: 569.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_4965",
    x1: 681.933,
    y1: 347.283,
    x2: 698,
    y2: 347.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_4965",
    x1: 658.564,
    y1: 429.147,
    x2: 690.698,
    y2: 429.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1_4965",
    x1: 733.772,
    y1: 325.179,
    x2: 735.987,
    y2: 570.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_4965",
    x1: 367.262,
    y1: 292.073,
    x2: 385.458,
    y2: 359.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_4965",
    x1: 414.248,
    y1: 329.603,
    x2: 417.68,
    y2: 316.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#B55D5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_4965",
    x1: 422.021,
    y1: 351.463,
    x2: 421.169,
    y2: 509.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1_4965",
    x1: 405.337,
    y1: 340.044,
    x2: 390.908,
    y2: 539.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_4965",
    x1: 438.61,
    y1: 440.972,
    x2: 497.442,
    y2: 440.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_4965",
    x1: 481.448,
    y1: 463.515,
    x2: 498.966,
    y2: 463.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_4965",
    x1: 342.135,
    y1: 431.053,
    x2: 486.576,
    y2: 431.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1_4965",
    x1: 327.323,
    y1: 431.896,
    x2: 319.94,
    y2: 394.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1_4965",
    x1: 199.932,
    y1: 313.08,
    x2: 208.748,
    y2: 301.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#FB929C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1_4965",
    x1: 216.66,
    y1: 336.308,
    x2: 207.281,
    y2: 521.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1_4965",
    x1: 256.148,
    y1: 323.439,
    x2: 253.923,
    y2: 569.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1_4965",
    x1: 231.511,
    y1: 350.145,
    x2: 215.294,
    y2: 350.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1_4965",
    x1: 255.096,
    y1: 432.817,
    x2: 222.663,
    y2: 432.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1_4965",
    x1: 180.562,
    y1: 319.811,
    x2: 178.6,
    y2: 536.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1_4965",
    x1: 151.312,
    y1: 332.079,
    x2: 107.149,
    y2: 493.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1_4965",
    x1: 184.963,
    y1: 480.744,
    x2: 187.289,
    y2: 448.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1_4965",
    x1: 177.776,
    y1: 339.353,
    x2: 133.618,
    y2: 500.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4862AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#455FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#3B569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8783,
    stopColor: "#2B4789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9893,
    stopColor: "#223F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1_4965",
    x1: 789.676,
    y1: 443.298,
    x2: 845.023,
    y2: 443.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1_4965",
    x1: 920.591,
    y1: 326.579,
    x2: 906.04,
    y2: 310.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#FB929C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1_4965",
    x1: 917.056,
    y1: 349.814,
    x2: 911.942,
    y2: 519.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1_4965",
    x1: 911.236,
    y1: 434.965,
    x2: 997.158,
    y2: 434.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1_4965",
    x1: 832.843,
    y1: 433.523,
    x2: 890.1,
    y2: 433.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1_4965",
    x1: 936.284,
    y1: 450.48,
    x2: 1012.01,
    y2: 442.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#7DBCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#72B4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    stopColor: "#60A6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1_4965",
    x1: 856.095,
    y1: 586.769,
    x2: 828.174,
    y2: 476.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1117,
    height: 697,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurcustomers);
export default __webpack_public_path__ + "static/media/our customers.eab5ba476c8e2839e8bed220d36ce692.svg";
export { ForwardRef as ReactComponent };